// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Futures trade page — Contract unit + Calculator modals (not used on margin page) */

.agcx-ft-modal-root {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  z-index: 99999999 !important;
  background-color: #00000020;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.agcx-ft-modal-panel.agcx-ft-modal-panel--transfer {
  -webkit-backdrop-filter: inherit;
          backdrop-filter: inherit;
}

body.light_theme .agcx-ft-modal-root {
  background-color: #ffffff2e;
}

.agcx-ft-modal-backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  background: rgb(255 255 255 / 20%);
}

.agcx-ft-modal-panel {
  position: relative;
  width: 100%;
  max-width: 420px;
  max-height: min(92vh, 720px);
  overflow: auto;
  border-radius: 14px;
  background: rgb(255 255 255 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.18);
}

.agcx-ft-modal-panel--calc {
  max-width: 720px;
}

.agcx-ft-modal-panel--avg {
  max-width: 820px;
}

.agcx-ft-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px 24px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  margin-bottom: 10px;
}

.agcx-ft-modal-title {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  color: #202020;
}

.limit_buy_plus {
  border: none;
}

.agcx-ft-modal-close {
  border: 0;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
  padding: 0px;
}

.agcx-ft-modal-body {
  padding: 18px 32px 32px;
}

.agcx-ft-modal-foot {
  padding: 0 18px 18px;
}

.agcx-ft-contract-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agcx-ft-contract-card {
  text-align: left;
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #fff;
  padding: 12px 14px;
  cursor: pointer;
}

.agcx-ft-modal-panel--contract {
  max-width: 520px;
}

.agcx-ft-contract-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 20px;
}

.agcx-ft-contract-card {
  text-align: left;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.agcx-ft-contract-card.is-selected {
  border-color: #0f172a;
  border-width: 1px;
  background: #fff;
}

.agcx-ft-contract-card__title {
  font-weight: 600;
  font-size: 16px;
  color: #0f172a;
  margin-bottom: 4px;
}

.agcx-ft-contract-card__desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.4;
}

.agcx-ft-modal-foot {
  padding: 12px 20px 24px;
}

.agcx-ft-btn--primary {
  width: 100%;
  background: #f1f5f9;
  border: none;
  color: #94a3b8;
  border-radius: 50px;
  font-weight: 600;
  height: 48px;
  font-size: 15px;
}

.agcx-ft-btn--primary.is-active {
  background: #0f172a;
  color: #fff;
}

.agcx-ft-btn--primary:not(:disabled) {
  background: #0f172a;
  color: #fff;
}

.agcx-ft-btn--primary:disabled {
  cursor: not-allowed;
  opacity: 0.85;
}

.agcx-ft-btn--ghost {
  background: #f1f5f9;
  color: #64748b;
}

.agcx-ft-btn--block {
  width: 100%;
  margin-top: 8px;
}

.agcx-ft-calc-tabs-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.agcx-ft-calc-tabs {
  display: flex;
  gap: 0;
  padding: 0 12px;
  overflow-x: auto;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge */
  flex: 1 1;
}

.agcx-ft-calc-tabs::-webkit-scrollbar {
  display: none;
  /* Chrome/Safari/Webkit */
}

.agcx-ft-calc-tab-arrow {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 32px;
  background: #fff;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  color: #0f172a;
  font-size: 18px;
  transition: opacity 0.2s;
}

.agcx-ft-calc-tab-arrow.left {
  left: 0;
  background: linear-gradient(to right, #fff 70%, rgba(255, 255, 255, 0));
}

.agcx-ft-calc-tab-arrow.right {
  right: 0;
  background: linear-gradient(to left, #fff 70%, rgba(255, 255, 255, 0));
}

.agcx-ft-calc-tab-arrow:hover {
  color: #2563eb;
}

.agcx-ft-calc-tab {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  position: relative;
  border-bottom: none;
  margin-bottom: -1px;
}

.agcx-ft-calc-tab:before {
  position: absolute;
  width: 30%;
  bottom: 0;
  left: 0;
  content: '';
  opacity: 0;
  right: 0;
  margin: 0 auto;
  height: 3px;
  background: #0f172a;
  transition: all 0.2s ease;
}

.agcx-ft-calc-tab.is-active:before {
  opacity: 1;
}

.agcx-ft-calc-tab.is-active {
  color: #0f172a;
  border-bottom-color: #0f172a;
}

.agcx-ft-calc-body {
  padding-top: 16px;
}

.agcx-ft-calc-grid {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 24px;
}

@media (max-width: 640px) {
  .agcx-ft-calc-grid {
    grid-template-columns: 1fr;
  }
}

.agcx-ft-calc-longshort {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.agcx-ft-calc-longshort button {
  flex: 1 1;
  border-radius: 8px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  padding: 7px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  background: #f1f5f9;
  color: #64748b;
  transition: all 0.2s ease;
}

.agcx-ft-calc-longshort button.is-on:first-child {
  background: #00c087;
  border-color: #00c087;
  color: #fff;
}

.agcx-ft-calc-longshort button.is-on:last-child {
  background: #f1f5f9;
  /* grey when not active, but the user screenshot shows grey for Short? Wait. */
  border-color: rgba(15, 23, 42, 0.12);
}

.agcx-ft-calc-longshort button:last-child.is-on {
  background: #ff3b30;
  border-color: #ff3b30;
  color: #fff;
}

.agcx-ft-calc-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #64748b;
}

.agcx-ft-calc-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  outline: none;
  color: #0f172a;
}

.agcx-ft-calc-input {
  display: flex;
  align-items: center;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  overflow: hidden;
  background: #f8fafc;
  transition: border-color 0.2s;
}

.agcx-ft-calc-input:focus-within {
  border-color: #0f172a;
}

.agcx-ft-calc-input input {
  flex: 1 1 auto;
  border: 0;
  background: transparent;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  outline: none;
  min-width: 0;
}

.agcx-ft-calc-input span {
  padding: 0 12px;
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
}

.agcx-ft-calc-results-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  min-height: 240px;
}

.agcx-ft-calc-out-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.agcx-ft-calc-out-row:last-of-type {
  border-bottom: 0;
}

.agcx-ft-calc-out-row span:first-child {
  font-size: 14px;
  color: #64748b;
}

.agcx-ft-calc-out-row span:last-child {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.agcx-ft-calc-liq-note {
  margin-top: auto;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.4;
  padding-top: 16px;
}

.agcx-ft-calc-avg-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.agcx-ft-calc-avg-head {
  display: grid;
  grid-template-columns: 28px 1fr 1fr 28px;
  gap: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  padding: 0 4px;
  margin-bottom: 4px;
}

.agcx-ft-modal-panel--avg .agcx-ft-calc-grid {
  grid-template-columns: 1.5fr 1fr;
}

.agcx-ft-calc-col.agcx-ft-calc-col--form .agcx-ft-calc-select {
  box-shadow: none;
  height: 42px;
  background: #F6F6F7;
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  /* backdrop-filter: blur(5px); */
  /* border-radius: 4px !important; */
  padding: 10px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px !important;
  overflow: hidden;
  background: #f8fafc;
  transition: border-color 0.2s;
}

.agcx-ft-calc-avg-row {
  display: grid;
  grid-template-columns: 28px 1fr 1fr 28px;
  gap: 12px;
  align-items: center;
  padding: 4px;
  border-radius: 8px;
  transition: background 0.2s;
}

.agcx-ft-calc-avg-row:hover {
  background: rgba(15, 23, 42, 0.02);
}

.avg-no {
  font-weight: 600;
  color: #0f172a;
  text-align: left;
  font-size: 14px;
}

.avg-action-col {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
}

.agcx-ft-calc-avg-delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  color: #ef4444;
  cursor: pointer;
  font-size: 18px;
  border-radius: 8px;
  transition: background 0.2s;
}

.agcx-ft-calc-avg-delete:hover {
  background: #fee2e2;
}

.agcx-ft-calc-add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px;
  background: #f8fafc;
  border: 1px dashed rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  color: #64748b;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.2s;
}

.agcx-ft-calc-add-btn:hover {
  background: #f1f5f9;
  color: #0f172a;
  border-color: #0f172a;
}

.agcx-ft-calc-note {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin: 0 18px 18px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f1f5f9;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

.agcx-ft-calc-note a {
  color: #0f172a;
  text-decoration: underline;
  font-weight: 500;
}

.limit_buy_calc_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  /* height: 32px; */
  margin-left: 0px;
  padding: 0px;
  border: 0;
  border-radius: 0px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background 0.2s;
}

.limit_buy_calc_btn:hover {
  background: rgba(15, 23, 42, 0.06);
}

.limit_buy_calc_icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
  filter: invert(1);
}

body.light_theme .limit_buy_calc_icon {
  filter: invert(0);
}

/* .limit_buy_calc_btn:hover {
  background: rgba(15, 23, 42, 0.06);
  color: #0f172a;
} */

.agcx-ft-amt-unit-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  border: 0;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
  padding: 4px 6px;
}

.agcx-ft-amt-unit-btn i {
  font-size: 16px;
  color: #64748b;
}


.spot_limit_dd_menu button {
  font-weight: 500;
}

/* —— Batch adjust drawer (leverage + margin mode only; no pair picker) —— */
.agcx-ft-batch-drawer-root {
  position: fixed;
  inset: 0;
  z-index: 100000000;
  pointer-events: none;
}

.agcx-ft-batch-drawer-root--open {
  pointer-events: auto;
}

.agcx-ft-batch-drawer-backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.55);
  opacity: 0;
  transition: opacity 0.35s ease;
}

.agcx-ft-batch-drawer-root--open .agcx-ft-batch-drawer-backdrop {
  opacity: 1;
}

body.light_theme .agcx-ft-batch-drawer-backdrop {
  background: rgba(15, 23, 42, 0.35);
}

.agcx-ft-batch-drawer-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(100%, 420px);
  max-width: 100%;
  display: flex;
  flex-direction: column;
  background: #1e2329;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.45);
  border-radius: 16px 0 0 16px;
  transform: translateX(100%);
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
  overflow: hidden;
}

body.light_theme .agcx-ft-batch-drawer-panel {
  background: #ffffff;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.12);
}

.agcx-ft-batch-drawer-root--open .agcx-ft-batch-drawer-panel {
  transform: translateX(0);
}

aside.agcx-ft-batch-drawer-panel header,
aside.agcx-ft-batch-drawer-panel footer {
  background-color: transparent;
}

.agcx-ft-batch-drawer-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 12px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
  background: #1e2329;
}

body.light_theme .agcx-ft-batch-drawer-head {
  border-bottom-color: #ececee;
  background: #ffffff;
}

.agcx-ft-batch-drawer-title {
  flex: 1 1 auto;
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  color: #eaecef;
  text-align: left;
}

body.light_theme .agcx-ft-batch-drawer-title {
  color: #14161a;
}

.agcx-ft-batch-drawer-iconbtn {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #848e9c;
  cursor: pointer;
  border-radius: 10px;
  font-size: 22px;
}

.agcx-ft-batch-drawer-iconbtn:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #eaecef;
}

body.light_theme .agcx-ft-batch-drawer-iconbtn {
  color: #7a7f8a;
}

body.light_theme .agcx-ft-batch-drawer-iconbtn:hover {
  background: #f2f3f5;
  color: #14161a;
}

.agcx-ft-batch-drawer-body {
  flex: 1 1 auto;
  overflow: auto;
  padding: 16px 16px 8px;
  -webkit-overflow-scrolling: touch;
}

.agcx-ft-batch-drawer-foot {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: #1e2329;
}

body.light_theme .agcx-ft-batch-drawer-foot {
  border-top-color: #ececee;
  background: #ffffff;
}

.agcx-ft-batch-section {
  margin-bottom: 8px;
  padding-bottom: 18px;
}

.agcx-ft-batch-section+.agcx-ft-batch-section {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 18px;
}

body.light_theme .agcx-ft-batch-section+.agcx-ft-batch-section {
  border-top-color: #ececee;
}

.agcx-ft-batch-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  min-height: 44px;
}

.agcx-ft-batch-row-text {
  flex: 1 1 auto;
  min-width: 0;
}

.agcx-ft-batch-row-label {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #eaecef;
}

body.light_theme .agcx-ft-batch-row-label {
  color: #14161a;
}

.agcx-ft-batch-row-sub {
  margin: 4px 0 0;
  font-size: 12.5px;
  line-height: 1.4;
  color: #848e9c;
}

body.light_theme .agcx-ft-batch-row-sub {
  color: #9a9da3;
}

.agcx-ft-batch-switch {
  position: relative;
  width: 40px;
  height: 22px;
  border-radius: 999px;
  border: 0;
  padding: 0;
  background: rgba(255, 255, 255, 0.12);
  cursor: pointer;
  transition: background 0.25s ease;
  flex-shrink: 0;
  margin-top: 2px;
}

body.light_theme .agcx-ft-batch-switch {
  background: #e2e8f0;
}

.agcx-ft-batch-switch.is-on {
  background: #d1aa67;
}

.agcx-ft-batch-switch-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.25s ease;
}

.agcx-ft-batch-switch.is-on .agcx-ft-batch-switch-knob {
  transform: translateX(18px);
}

.agcx-ft-batch-leverage-block {
  margin-top: 14px;
  margin-bottom: 4px;
}

.agcx-ft-batch-lvg-input-wrap {
  display: flex;
  align-items: stretch;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 10px;
  overflow: hidden;
  background: #f8fafc;
}

.agcx-ft-batch-lvg-input {
  flex: 1 1 auto;
  border: 0;
  padding: 12px 8px 12px 14px;
  font-size: 16px;
  font-weight: 600;
  background: transparent;
  min-width: 0;
  outline: none;
}

.agcx-ft-batch-lvg-suffix {
  display: flex;
  align-items: center;
  padding-right: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
}

.agcx-ft-batch-lvg-stepper {
  display: flex;
  flex-direction: column;
  border-left: 1px solid rgba(15, 23, 42, 0.08);
  flex-shrink: 0;
}

.agcx-ft-batch-lvg-stepper button {
  flex: 1 1;
  min-height: 24px;
  padding: 0 10px;
  border: 0;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
  cursor: pointer;
  font-size: 10px;
  line-height: 1;
  color: #64748b;
}

.agcx-ft-batch-lvg-stepper button:hover {
  background: #f1f5f9;
}

.agcx-ft-batch-lvg-slider-wrap {
  position: relative;
  margin-top: 20px;
  padding-bottom: 28px;
  --lvg-thumb-half: 9px;
}

.agce-ft-lvg-slider-rail {
  position: relative;
  margin: 0 var(--lvg-thumb-half);
}

.agcx-ft-batch-lvg-track-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 10px;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.2);
  pointer-events: none;
}

body.light_theme .agcx-ft-batch-lvg-track-bg {
  background: #e2e8f0;
}

.agcx-ft-batch-lvg-track-fill {
  position: absolute;
  left: 0;
  top: 10px;
  height: 4px;
  border-radius: 2px;
  background: #ffffff;
  pointer-events: none;
  z-index: 1;
  transition: width 0.05s ease-out;
}

body.light_theme .agcx-ft-batch-lvg-track-fill {
  background: #0f172a;
}

.agcx-ft-batch-lvg-range {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 24px;
  margin: 0;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

.agcx-ft-batch-lvg-range::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #0f172a;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  margin-top: -7px;
}

.agcx-ft-batch-lvg-range::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #0f172a;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.agcx-ft-batch-lvg-range::-webkit-slider-runnable-track {
  height: 4px;
  background: transparent;
}

.agcx-ft-batch-lvg-range::-moz-range-track {
  height: 4px;
  background: transparent;
}

.agcx-ft-batch-lvg-ticks {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  padding: 0 2px;
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
}

/* Leverage modal — − / value / + stepper + diamond tick marks */
.agce-margin-lvg-slider-block {
  margin-bottom: 16px;
}

.agce-margin-lvg-step-row {
  display: flex;
  align-items: stretch;
  border: 1px solid #cbd5e10f;
  border-radius: 10px;
  overflow: hidden;
  background: #222325;
  margin-bottom: 16px;
}

body.light_theme .agce-margin-lvg-step-row {
  border: 1px solid #cbd5e1;
  background: #f8fafc;
}

.agce-margin-lvg-step-row button {
  flex: 0 0 48px;
  border: 0;
  background: #222325;
  font-size: 22px;
  line-height: 1.5;
  color: #e6e6e6;
  cursor: pointer;
}

body.light_theme .agce-margin-lvg-step-row button {
  background: #fff;
  color: #334155;
}

.agce-margin-lvg-step-row button:first-child {
  border-right: 1px solid #e2e8f01a;
}

body.light_theme .agce-margin-lvg-step-row button:first-child {
  border-right: 1px solid #e2e8f0;
}

.agce-margin-lvg-step-row button:last-child {
  border-left: 1px solid #e2e8f01a;
}

body.light_theme .agce-margin-lvg-step-row button:last-child {
  border-left: 1px solid #e2e8f0;
}

.agce-margin-lvg-step-row button:hover {
  opacity: 0.8;
}

.agce-margin-lvg-step-val {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}

body.light_theme .agce-margin-lvg-step-val {
  color: #0f172a;
}

.agce-ft-lvg-slider-ticks {
  position: relative;
  display: block;
  height: 36px;
  margin: 2px var(--lvg-thumb-half, 9px) 0;
}

.agce-ft-lvg-slider-ticks .agcx-ft-batch-lvg-tick {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  border: 0;
  background: transparent;
  padding: 0;
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.agce-ft-lvg-slider-ticks .agcx-ft-batch-lvg-tick.is-active {
  color: #b2b2b2;
  font-weight: 700;
}

body.light_theme .agce-ft-lvg-slider-ticks .agcx-ft-batch-lvg-tick.is-active {
  color: #0f172a;
}

.agce-margin-lvg-tick-diamond {
  display: block;
  width: 8px;
  height: 8px;
  border: 2px solid #cbd5e1;
  background: #fff;
  transform: rotate(45deg);
}

.agce-ft-lvg-slider-ticks .agcx-ft-batch-lvg-tick.is-active .agce-margin-lvg-tick-diamond {
  border-color: #0f172a;
  border-width: 2px;
}

.agce-margin-lvg-notes {
  margin: 0 0 12px;
  padding-left: 0px;
  font-size: 12px;
  line-height: 1.5;
  color: #bbbbbb;
}

body.light_theme .agce-margin-lvg-notes {
  color: #64748b;
}

.agce-margin-lvg-notes li {
  margin-bottom: 8px;
}

.agce-margin-lvg-notes li:last-child {
  margin-bottom: 0;
}

.agce-margin-lvg-notes a {
  color: #c99400;
  text-decoration: none;
}

.agce-margin-lvg-notes a:hover {
  text-decoration: underline;
}

.agcx-ft-batch-mode-segment {
  position: relative;
  display: flex;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 4px;
  margin-top: 14px;
}

body.light_theme .agcx-ft-batch-mode-segment {
  background: #f2f3f5;
}

.agcx-ft-batch-mode-segment__thumb {
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 8px);
  background: #eaecef;
  border-radius: 9px;
  transition: transform 0.22s ease;
  pointer-events: none;
  z-index: 0;
}

body.light_theme .agcx-ft-batch-mode-segment__thumb {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.agcx-ft-batch-mode-segment__thumb.is-isolated {
  transform: translateX(100%);
}

.agcx-ft-batch-mode-segment__btn {
  position: relative;
  z-index: 1;
  flex: 1 1;
  min-height: 40px;
  border: 0;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: #848e9c;
  cursor: pointer;
  border-radius: 9px;
}

body.light_theme .agcx-ft-batch-mode-segment__btn {
  color: #9a9da3;
}

.agcx-ft-batch-mode-segment__btn.is-active {
  color: #1e2329;
}

body.light_theme .agcx-ft-batch-mode-segment__btn.is-active {
  color: #14161a;
}

.agcx-ft-batch-warn {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 8px 0 12px;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(209, 170, 103, 0.12);
  border: 1px solid rgba(209, 170, 103, 0.28);
}

body.light_theme .agcx-ft-batch-warn {
  background: rgba(209, 170, 103, 0.1);
  border-color: rgba(209, 170, 103, 0.35);
}

.agcx-ft-batch-warn__icon {
  flex-shrink: 0;
  font-size: 14px;
  line-height: 1.4;
  color: #d1aa67;
}

.agcx-ft-batch-warn p {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #c9b07a;
}

body.light_theme .agcx-ft-batch-warn p {
  color: #8a7340;
}

.agcx-ft-batch-confirm {
  width: 100%;
  min-height: 48px;
  border: 0;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  background: #d1aa67;
  color: #1e2329;
  transition: filter 0.2s, opacity 0.2s;
}

.agcx-ft-batch-confirm:hover:not(:disabled) {
  filter: brightness(1.05);
}

.agcx-ft-batch-confirm:disabled {
  background: rgba(255, 255, 255, 0.08);
  color: #5e6673;
  cursor: not-allowed;
  filter: none;
}

body.light_theme .agcx-ft-batch-confirm:not(:disabled) {
  background: #d1aa67;
  color: #14161a;
}

body.light_theme .agcx-ft-batch-confirm:disabled {
  background: #e7e9ec;
  color: #a9adb5;
}



.agcx-ft-modal-panel--transfer {
  max-width: 712px;
}

.agcx-ft-transfer-body {
  padding: 16px 24px 24px;
}

.agcx-ft-transfer-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  /* background: #fdfaf2; */
  border: 1px solid #E4E4E4;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 24px;
  position: relative;
}

.agcx-ft-transfer-banner .banner-icon {
  width: 47px;
  /* height: 32px; */
  flex-shrink: 0;
}

.agcx-ft-transfer-banner .banner-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.agcx-ft-transfer-banner .banner-text {
  font-size: 14px;
  color: #e5e5e5;
  font-weight: 500;
  flex: 1 1;
  line-height: 1.4;
}

body.light_theme .agcx-ft-transfer-banner .banner-text {
  color: #101828;
}

.agcx-ft-transfer-banner .banner-close {
  background: transparent;
  border: 0;
  color: #101828;
  opacity: 0.7;
  cursor: pointer;
  padding: 4px;
}

.agcx-ft-transfer-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 5px;
}

.agcx-ft-transfer-field {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.agcx-ft-transfer-field label {
  font-size: 18px;
  font-weight: 500;
  color: #303236;
}

.agcx-ft-transfer-box {
  background: none;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
}

.agcx-ft-transfer-box.is-select {
  cursor: pointer;
}

.agcx-ft-transfer-box.is-coin {
  padding: 8px 16px;
  cursor: pointer;
}

.agcx-ft-transfer-box .coin-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.agcx-ft-transfer-box .coin-info img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.agcx-ft-transfer-swap {
  width: 36px;
  min-width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  margin-bottom: 0px;
  transition: all 0.2s;
}

.agcx-ft-transfer-swap img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.agcx-ft-transfer-swap:hover {
  border-color: #0f172a;
  background: #f8fafc;
}


.agcx-ft-transfer-input-wrap {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 12px;
  padding: 0 16px;
  transition: border-color 0.2s;
}

.agcx-ft-transfer-input-wrap:focus-within {
  border-color: #0f172a;
}

.agcx-ft-transfer-input-wrap input {
  flex: 1 1;
  border: 0;
  background: transparent;
  padding: 14px 0;
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  outline: none;
}

.agcx-ft-transfer-input-wrap .input-suffix {
  display: flex;
  align-items: center;
  gap: 12px;
}

.agcx-ft-transfer-input-wrap .input-suffix span {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.agcx-ft-transfer-input-wrap .input-suffix .divider {
  width: 1px;
  height: 20px;
  background: rgba(15, 23, 42, 0.1);
}

.agcx-ft-transfer-input-wrap .all-btn {
  background: transparent;
  border: 0;
  color: #D1AA67;
  padding: 0px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

.agcx-ft-transfer-avail {
  margin-top: 0px;
  font-size: 12px;
  color: #B4B8C0;
  font-weight: 500;
}

@keyframes agcx-ft-transfer-skeleton-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.agcx-ft-transfer-balance-skeleton {
  display: inline-block;
  vertical-align: middle;
  width: 100px;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #2a2e36 0%, #3a3f4a 45%, #2a2e36 90%);
  background-size: 200% 100%;
  animation: agcx-ft-transfer-skeleton-shimmer 1.35s ease-in-out infinite;
}

body.light_theme .agcx-ft-transfer-balance-skeleton {
  background: linear-gradient(90deg, #e8eaed 0%, #f1f5f9 45%, #e8eaed 90%);
  background-size: 200% 100%;
  animation: agcx-ft-transfer-skeleton-shimmer 1.35s ease-in-out infinite;
}

.agcx-ft-btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agcx-ft-transfer-actions {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 16px;
  margin-top: 12px;
}

.agcx-ft-btn--ghost {
  background: #DDDDDD;
  color: #303236;
  border: none;
  border-radius: 50px;
  font-weight: 500;
}

/* 
.agcx-ft-btn--ghost:hover {
  background: #e2e8f0;
} */

.agcx-ft-transfer-field--to,
.agcx-ft-transfer-field--from {
  position: relative;
}

.agcx-ft-transfer-box.is-select.is-active {
  border-color: #0f172a;
}

.agcx-ft-transfer-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 12px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  z-index: 100;
  overflow: hidden;
  padding: 8px 0;
}

.agcx-ft-transfer-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;
}

.agcx-ft-transfer-dropdown-item:hover {
  background: #f8fafc;
}

.agcx-ft-transfer-dropdown-item.is-selected {
  color: #2563eb;
  font-weight: 600;
}

.agcx-ft-transfer-dropdown-item .item-label {
  font-size: 14px;
}

.agcx-ft-transfer-dropdown-item .item-action {
  font-size: 12px;
  color: #2563eb;
  font-weight: 500;
}

.agcx-ft-transfer-dropdown--coins {
  max-height: 280px;
  overflow-y: auto;
}

.agcx-ft-transfer-dropdown--coins .coin-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.agcx-ft-transfer-dropdown--coins .coin-info img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.agcx-ft-transfer-dropdown--coins .text-primary {
  color: #2563eb !important;
}

/* Quick-select coin chips (below Coin field) */
.agcx-ft-transfer-quick-coins {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 10px;
}

.agcx-ft-quick-coin {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.agcx-ft-quick-coin-radio {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  background: #fff;
  flex-shrink: 0;
  position: relative;
  transition: border-color 0.15s;
}

.agcx-ft-quick-coin-radio.is-checked {
  border-color: #272727;
}

.agcx-ft-quick-coin-radio.is-checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #272727;
}

.dark-mode .agcx-ft-quick-coin {
  color: #f1f5f9;
}

.dark-mode .agcx-ft-quick-coin-radio {
  border-color: #475569;
  background: #1e293b;
}

.agcx-ft-modal-panel--coin-select {
  max-width: 540px;
  min-height: 580px;
  display: flex;
  flex-direction: column;
}

.agcx-ft-coin-search {
  position: relative;
  margin: 16px 20px;
}

.agcx-ft-coin-search input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  font-size: 14px;
  color: #0f172a;
  outline: none;
  transition: all 0.2s;
}

/* .agcx-ft-coin-search input:focus {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
} */

.agcx-ft-coin-search i {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  font-size: 18px;
}

.agcx-ft-coin-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 12px 16px;
  max-height: 440px;
}

.agcx-ft-coin-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 4px;
}

.agcx-ft-coin-item:hover {
  background: #f8fafc;
}

.coin-item-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.coin-item-left img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: contain;
}

.coin-item-info {
  display: flex;
  flex-direction: column;
}

.coin-short {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.coin-full {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.agcx-ft-coin-item .ri-check-line {
  color: #000000 !important;
  font-size: 20px;
}

.agcx-ft-amt-unit-btn {
  display: flex !important;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 0;
  padding: 0 0px !important;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  height: 100%;
}

body .trade-wrapper.spot span.input-group-text.text-start.trade_amount_coin_badge {
  padding: 0px !important;
}

.agcx-ft-amt-unit-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 0;
  padding: 0 8px;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  height: 100%;
  transition: all 0.2s;
}

.agcx-ft-amt-unit-btn:hover {
  color: #0f172a;
}

.agcx-ft-amt-unit-btn span {
  color: inherit;
}

.agcx-ft-amt-unit-btn i {
  font-size: 14px;
  color: #94a3b8;
}

/* Sub-fields Collapsible Sections */
.agcx-ft-checkbox-fields-wrap {
  margin: 5px 0px 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.stop_checks.limit_buy_checks {
  /* justify-content: space-between; */
  width: 100%;
  flex-direction: row;
  font-size: 12px;
  gap: 25px;
}

/* .stop_check {
  width: 100%;
} */

.stop_checks.limit_buy_checks.d-flex.align-items-center.mb-0 {
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
}

.stop_checks.limit_buy_checks.d-flex.align-items-center.mt-2.mb-2 {
  flex-direction: row;
}

.stop_checks.limit_buy_checks span {
  color: #484848;
}

@keyframes agcxFadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}


.agcx-ft-desktop-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.agcx-ft-desktop-actions .btn {
  flex: 1 1;
  height: 40px;
  border-radius: 50px;
  font-weight: 500;
  font-size: 14px;
  border: none;
}

.agcx-ft-desktop-actions .btn-buy {
  background: #00c087;
  color: #ffffff;
}

.agcx-ft-desktop-actions .btn-sell {
  background: #f84960;
  color: #ffffff;
}

.agcx-ft-trade-info {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  padding: 0 4px;
}

.agcx-ft-trade-info-column {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.agcx-ft-trade-info-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #848e9c;
}

.agcx-ft-trade-info-label {
  color: #848e9c;
}

.agcx-ft-trade-info-value {
  color: #f0b90b;
  font-weight: 500;
}

/* Dark mode overrides if needed, but #848e9c is standard */
.agcx-ft-trade-info-value {
  color: #ffffff;
}

body.light_theme .agcx-ft-trade-info-value {
  color: #000000;
}

.agcx-ft-desktop-actions .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


.agcx-ft-subfield-section.no-header {
  padding-top: 12px;
  width: 100%;
}

.dark-mode .agcx-ft-subfield-section {
  background: #1e293b;
  border-color: #334155;
}


.agcx-ft-subfield-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.agcx-ft-subfield-title {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.agcx-ft-subfield-link {
  font-size: 12px;
  color: #efefef;
  text-decoration: none;
}

body.light_theme .agcx-ft-subfield-link {
  color: #000000;
}

.agcx-ft-subfield-link:hover {
  text-decoration: underline;
  color: #efefef;
}

body.light_theme .agcx-ft-subfield-link:hover {
  color: #000000;
}

.agcx-ft-subfield-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}

.agcx-ft-subfield-row:last-child {
  margin-bottom: 0;
}

.agcx-ft-subfield-label {
  font-size: 12px;
  color: #94a3b8;
}

.agcx-ft-subfield-input-group {
  display: flex;
  align-items: center;
  background: #2B313C;
  /* border: 1px solid #f5f6f714; */
  border-radius: 6px;
  height: 43px;
  overflow: hidden;
  transition: border-color 0.2s;
}

body.light_theme .agcx-ft-subfield-input-group {
  background: #F5F6F7;
  border: 1px solid #F5F6F7;
}

.dark-mode .agcx-ft-subfield-input-group {
  background: #0f172a;
  border-color: #334155;
}

.agcx-ft-subfield-input-group:focus-within {
  border-color: #3b82f6;
}

.agcx-ft-subfield-input {
  flex: 1 1;
  background: transparent;
  border: 0;
  padding: 0 12px;
  color: #fff;
  font-size: 14px;
  outline: none;
  width: 100%;
  font-weight: 500;
}

body.light_theme .agcx-ft-subfield-input {
  color: #1e293b;
}

.dark-mode .agcx-ft-subfield-input {
  color: #f8fafc;
}

.agcx-ft-subfield-unit-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 0;
  padding: 0 10px;
  height: 100%;
  color: #f7f7f7;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

body.light_theme .agcx-ft-subfield-unit-btn {
  color: #000000;
}

.dark-mode .agcx-ft-subfield-unit-btn {
  background: #1e293b;
  border-left-color: #334155;
  color: #94a3b8;
}

.agcx-ft-subfield-unit-btn i {
  font-size: 14px;
  color: #94a3b8;
}

/* Specific button styles to override existing ones if needed */
.agcx-ft-amt-unit-btn span {
  font-weight: 600;
  color: #fff;
}

body.light_theme .agcx-ft-amt-unit-btn span {
  color: #0f172a;
}

.dark-mode .agcx-ft-amt-unit-btn span {
  color: #f8fafc;
}

.trade_amount_coin_badge {
  background: transparent !important;
  border-left: 0 !important;
  padding-left: 0 !important;
}

.trade_amount_field_wrap,
.trade_amount_field_limit {
  position: relative;
  overflow: visible;
}

.agcx-ft-amt-hint {
  position: absolute;
  left: 10px;
  bottom: calc(100% - 8px);
  z-index: 30;
  max-width: calc(100% - 12px);
  padding: 6px 8px;
  border-radius: 4px;
  background: #2b313d;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}

.agcx-ft-amt-hint::after {
  content: "";
  position: absolute;
  left: 18px;
  bottom: -5px;
  border-width: 5px 5px 0;
  border-style: solid;
  border-color: #3d3d3d transparent transparent;
}

/* TIF Modal Styles */
.agcx-ft-modal-panel--tif {
  max-width: 660px;
}

.agcx-ft-tif-card {
  background: #00000052;
  border: none;
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  transition: all 0.2s;
  box-shadow: 0px 0px 18px #c5c5c50f;
}

body.light_theme .agcx-ft-tif-card {
  background: #ffffff;
  box-shadow: 0px 0px 18px #c5c5c573;
}

/* .agcx-ft-tif-card:hover {
  border-color: #cbd5e1 !important;
  background: #f8fafc !important;
} */

.agcx-ft-tif-card.is-selected {
  border-color: #0f172a !important;
  background: #00000052 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

body.light_theme .agcx-ft-tif-card.is-selected {
  background: #ffffff !important;
}

.agcx-ft-tif-card__title {
  font-weight: 500;
  font-size: 18px;
  color: #dfdfdf;
  margin-bottom: 10px;
}

body.light_theme .agcx-ft-tif-card__title {
  color: #282e3b;
}

.agcx-ft-tif-card__desc {
  font-size: 16px;
  color: #748093;
  line-height: 1.4;
}

.agcx-ft-tif-check-box {
  border: 1.5px solid #e2e8f0;
  border-radius: 4px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.agcx-ft-modal-body .agcx-ft-contract-list {
  padding: 0px;
}

.agcx-ft-modal-body .agcx-ft-coin-list {
  padding: 0px;
}

.agcx-ft-modal-body .agcx-ft-coin-search {
  margin: 0px;
  margin-bottom: 10px;
}

.agcx-ft-tif-check-box.is-checked {
  background: #0f172a;
  border-color: #0f172a;
}

.agcx-ft-tif-check-box.is-checked i {
  color: #ffffff;
  font-size: 14px;
}

.dark-mode .agcx-ft-tif-card {
  background: #1e293b !important;
  border-color: #334155 !important;
}

.dark-mode .agcx-ft-tif-card.is-selected {
  border-color: #f8fafc !important;
  background: #1e293b !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.dark-mode .agcx-ft-tif-card__title {
  color: #f8fafc !important;
}

.dark-mode .agcx-ft-tif-card__desc {
  color: #94a3b8 !important;
}

.dark-mode .agcx-ft-tif-check-box {
  border-color: #475569;
}

.dark-mode .agcx-ft-tif-check-box.is-checked {
  background: #f8fafc !important;
  border-color: #f8fafc !important;
}

.dark-mode .agcx-ft-tif-check-box.is-checked i {
  color: #0f172a !important;
}

/* TIF row — label + button (moved from inline styles) */
.agcx-ft-tif-label {
  color: #94a3b8;
  font-size: 14px;
  font-weight: 400;
}

.agcx-ft-tif-btn {
  background: none;
  border: 0;
  padding: 0;
  color: #e1e1e1;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

body.light_theme .agcx-ft-tif-btn {
  color: #0f172a;
}

.agcx-ft-tif-btn i {
  font-size: 18px;
}

.dark-mode .agcx-ft-tif-label {
  color: #94a3b8;
}

.dark-mode .agcx-ft-tif-btn {
  color: #f8fafc !important;
}




@media (max-width: 1024px) {

  .static-action-btn {
    padding: 4px 18px;
  }

  .agcx-ft-modal-root {
    z-index: 9999999999 !important;
  }

}

@media (max-width: 767px) {


  .agcx-ft-trade-info {
    margin: 10px 0px;
    padding: 0 0px;
  }

  .headline_left__lBBPY .scroll-subtabs_tabs__Prom8 {
    padding-right: 0px;
  }

  .agcx-ft-trade-info-value {
    font-weight: 400;
  }

  .agcx-ft-modal-panel--calc {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .agcx-ft-modal-root {
    align-items: end;
    z-index: 99999999;
  }

  .agcx-ft-modal-panel {
    width: 100%;
    max-width: 100%;
    border-radius: 14px 14px 0px 0px;
  }

  .agcx-margin-lvg-modal-panel {
    height: 85vh;
    overflow: scroll;
  }

  .agcx-ft-tif-card__title {
    font-size: 16px;
  }

  .agcx-ft-tif-card__desc {
    font-size: 14px;
  }

  .agcx-ft-modal-body {
    padding: 20px 20px 22px;
  }

  .agcx-ft-modal-head {
    padding: 18px 20px 18px;
    margin-top: 0px;
  }

  .agcx-ft-modal-title {
    font-size: 20px;
  }



  .agcx-ft-transfer-field label {
    font-size: 14px;
  }

  .agcx-ft-transfer-swap {
    padding: 0px;
  }

  .agcx-ft-modal-body .agcx-ft-coin-list {
    padding: 0px;
    max-width: 100%;
  }

  .agcx-ft-modal-body .agcx-ft-coin-search {
    margin: 0px;
  }

  .agcx-ft-batch-confirm {
    min-height: 42px;
    font-size: 12px;
  }

  .agcx-ft-btn--primary {
    height: 36px;
    font-size: 12px;
  }

  .agcx-ft-transfer-box {
    border-radius: 8px;
    padding: 10px 11px;
    font-size: 13px;
    min-height: 44px;
  }

  .agcx-ft-calc-results-card {
    min-height: 100%;
  }

}

/* Desktop assets rail — Contract Details card (futures_trade) */
.assets_panel_list_card .assets_contract_details {
  padding: 4px 0 8px;
}

.assets_contract_details_title {
  margin: 20px 0 10px;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  font-family: "Inter", sans-serif;
  border-bottom: 1px solid #EDEFF2;
  padding-bottom: 10px;
}

.assets_contract_details_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 7px 0;
  font-size: 12px;
  font-family: "Inter", sans-serif;
}

.assets_contract_details_label {
  color: #686868;
  font-weight: 400;
  flex-shrink: 0;
}

.assets_contract_details_val {
  color: #191919;
  text-align: right;
  min-width: 0;
}

.static-action-btn {
  font-size: 11px;
  background: #303236;
  color: #fff !important;
  border: none !important;
  transition: all 0.2s ease;
}

.static-action-btn:hover {
  background: #3c3e42;
  color: #fff !important;
}

.static-table-wrap {
  min-height: 350px;
  max-height: 500px;
  overflow-y: auto;
}

/* Hiding mobile view on desktop */
.order_history_mobile_view,
.so-mobile,
.twomobile {
  display: none !important;
}



/* Centering No-Data State across different sections */
.spot_orders_placeholder_shell,
.spot_orders_no_data_row td,
.no-data-wrapper,
.orderbook-empty-state,
.no_data_s {
  align-items: center !important;
  justify-content: center !important;
  min-height: 200px !important;
  width: 100% !important;
  flex-direction: column !important;
  text-align: center !important;
}

.spot_orders_empty_state {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 40px 0 !important;
  width: 100% !important;
}

.spot_orders_empty_telescope {
  margin: 0 auto !important;
}

.adl-dot {
  width: 6px;
  height: 6px;
  background-color: #0ecb81;
  border-radius: 50%;
}

/* ADL — 5 equal dots (not signal bars) */
.agce-ft-adl {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  min-width: 42px;
}

.agce-ft-adl-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #d5dae2;
  flex-shrink: 0;
}

.agce-ft-adl-dot--on.agce-ft-adl-dot--low {
  background-color: #0ecb81;
}

.agce-ft-adl-dot--on.agce-ft-adl-dot--mid {
  background-color: #f0b90b;
}

.agce-ft-adl-dot--on.agce-ft-adl-dot--high {
  background-color: #f6465d;
}

.agce-ft-wallet-hist-pager {
  border-top: 1px solid #eaecef;
}

/* Right-bottom Account panel (Binance-style) */
.assets_right.agce-ft-acct-rail {
  border-radius: 8px;
  padding: 0;
  min-width: 19%;
  max-width: 19%;
  flex-shrink: 0;
}

.agce-ft-acct-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 14px 14px 12px;
  font-family: "Inter", sans-serif;
  color: #1e2329;
}

.agce-ft-acct-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #eaecef;
  margin-bottom: 12px;
}

.agce-ft-acct-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

body.light_theme .agce-ft-acct-title {
  color: #1e2329;
}

.agce-ft-acct-switch {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #f0b90b;
  text-decoration: none !important;
}

.agce-ft-acct-switch:hover {
  color: #d9a409;
}

.agce-ft-acct-section {
  margin-bottom: 10px;
}

.agce-ft-acct-section-title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

body.light_theme .agce-ft-acct-section-title {
  color: #1e2329;
}

.agce-ft-acct-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 0;
  font-size: 12px;
}

.agce-ft-acct-row--main {
  font-weight: 500;
  color: #fff;
  padding-bottom: 6px;
}

body.light_theme .agce-ft-acct-row--main {
  color: #1e2329;
}

.agce-ft-acct-row-end {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.agce-ft-acct-label {
  color: #848e9c;
}

body.light_theme .agce-ft-acct-val {
  color: #1e2329;
}

.agce-ft-acct-val {
  color: #dedede;
  font-weight: 500;
  text-align: right;
}

.agce-ft-acct-val--profit {
  color: #0ecb81 !important;
}

.agce-ft-acct-val--loss {
  color: #f6465d !important;
}

.agce-ft-acct-mode-btn {
  width: 100%;
  border: none;
  border-radius: 6px;
  background: #f0f1f2;
  color: #1e2329;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 12px;
  margin-bottom: 12px;
  cursor: default;
}

.agce-ft-acct-section--asset {
  border-top: 1px solid #eaecef;
  padding-top: 10px;
  margin-bottom: 10px;
}

.agce-ft-acct-asset-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: none;
  background: transparent;
  padding: 0 0 6px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

body.light_theme .agce-ft-acct-asset-toggle {
  color: #1e2329;
}

.agce-ft-acct-pnl-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  border: 1px solid #eaecef;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #1e2329;
  text-decoration: none !important;
  transition: background 0.15s ease;
}

.agce-ft-acct-pnl-link:hover {
  background: #fafafa;
  color: #1e2329;
}

.agce-ft-acct-pnl-link i {
  font-size: 16px;
  color: #848e9c;
}

.agce-ft-acct-actions {
  display: flex;
  gap: 6px;
}

.agce-ft-acct-action-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  border: none;
  border-radius: 6px;
  background: #f0f1f2;
  color: #1e2329 !important;
  font-size: 11px;
  font-weight: 500;
  text-decoration: none !important;
  padding: 6px 4px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.agce-ft-acct-action-btn:hover {
  background: #e8eaed;
  color: #1e2329 !important;
}

.agce-ft-acct-login {
  padding: 24px 12px;
  text-align: center;
  font-size: 12px;
  color: #848e9c;
}

.agce-ft-acct-login-btn {
  display: inline-block;
  margin-top: 8px;
  padding: 6px 16px;
  border-radius: 6px;
  background: #d1aa67;
  color: #1e2329 !important;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none !important;
}

html[data-theme="dark"] .assets_right.agce-ft-acct-rail {
  background: #181a20;
  border-color: #2b3139;
}

html[data-theme="dark"] .agce-ft-acct-panel {
  color: #eaecef;
}

html[data-theme="dark"] .agce-ft-acct-title,
html[data-theme="dark"] .agce-ft-acct-section-title,
html[data-theme="dark"] .agce-ft-acct-row--main,
html[data-theme="dark"] .agce-ft-acct-val,
html[data-theme="dark"] .agce-ft-acct-asset-toggle,
html[data-theme="dark"] .agce-ft-acct-pnl-link {
  color: #eaecef;
}

html[data-theme="dark"] .agce-ft-acct-head,
html[data-theme="dark"] .agce-ft-acct-section--asset {
  border-color: #2b3139;
}

html[data-theme="dark"] .agce-ft-acct-mode-btn,
html[data-theme="dark"] .agce-ft-acct-action-btn {
  background: #2b3139;
  color: #eaecef !important;
}

html[data-theme="dark"] .agce-ft-acct-pnl-link {
  border-color: #2b3139;
}

html[data-theme="dark"] .agce-ft-acct-pnl-link:hover {
  background: #2b3139;
}

/* Positions table — Close opens modal (no inline price/qty inputs) */
.agce-ft-close-pos-cell {
  vertical-align: middle !important;
  text-align: right;
  min-width: 88px;
}

.agce-ft-close-pos__open-btn {
  border: none !important;
  border-radius: 6px !important;
  background: #30323600 !important;
  color: #d09f52 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  padding: 8px 14px !important;
  cursor: pointer !important;
  transition: background 0.15s ease, opacity 0.15s ease !important;
  text-decoration: underline !important;
}

.agce-ft-close-pos__open-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
}

.agce-ft-close-pos__open-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

body.light_theme .agce-ft-close-pos__open-btn {
  background: #f0f1f2;
  color: #b45309;
}

body.light_theme .agce-ft-close-pos__open-btn:hover:not(:disabled) {
  background: #e5e7eb;
}

.so-mobileCard__row .agce-ft-close-pos__open-btn {
  width: 100%;
  max-width: 140px;
}

.agce-ft-pos-margin {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.agce-ft-pos-margin__text {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.agce-ft-pos-margin__value {
  font-weight: 600;
}

.agce-ft-pos-margin__mode {
  font-size: 11px;
  color: #848e9c;
}

.agce-ft-pos-margin__edit {
  border: none;
  background: transparent !important;
  color: #848e9c !important;
  padding: 0 !important;
  cursor: pointer;
  font-size: 15px !important;
  font-weight: 800 !important;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.agce-ft-pos-margin__edit:hover {
  color: #d1aa67;
}

body.light_theme .agce-ft-pos-margin__mode,
body.light_theme .agce-ft-pos-margin__edit {
  color: #9a9da3;
}

body.light_theme .agce-ft-pos-margin__edit:hover {
  color: #d1aa67;
}

.agce-ft-adj-margin-hint {
  margin: 4px 0 14px;
  font-size: 12px;
  color: #848e9c;
}

body.light_theme .agce-ft-adj-margin-hint {
  color: #9a9da3;
}

/* Futures close position modal */
.agce-ft-close-modal-dialog {
  max-width: 380px !important;
  width: calc(100% - 32px);
  margin: 1rem auto;
}

.agce-ft-close-modal-content {
  overflow: hidden;
}

.agce-ft-close-modal-side-pill {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  line-height: 1.3;
}

.agce-ft-close-modal-side-pill--long {
  background: rgba(1, 188, 141, 0.15);
  color: #01bc8d;
}

.agce-ft-close-modal-side-pill--short {
  background: rgba(228, 85, 97, 0.15);
  color: #e45561;
}

.agce-ft-close-modal-tabs {
  display: flex;
  gap: 0;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  padding: 3px;
  margin-bottom: 16px;
}

body.light_theme .agce-ft-close-modal-tabs {
  background: #f3f4f6;
}

.agce-ft-close-modal-tab {
  flex: 1 1;
  border: none;
  background: transparent;
  color: #9ca3af;
  border-radius: 8px;
  padding: 8px 0;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.agce-ft-close-modal-tab.is-active {
  background: rgb(43 49 61);
  color: #fff;
}

body.light_theme .agce-ft-close-modal-tab.is-active {
  background: #fff;
  color: #111827;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.agce-ft-close-modal-field-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.agce-ft-close-modal-field-label-row label {
  margin: 0;
}

.agce-ft-close-modal-mark-hint {
  font-size: 12px;
  color: #9ca3af;
}

.agce-ft-close-modal-pcts {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}

.agce-ft-close-modal-pct {
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: #2B313C;
  color: #d1d5db;
  border-radius: 8px;
  padding: 9px 0;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.agce-ft-close-modal-pct.is-active {
  background: rgb(209 170 103 / 10%);
  border-color: rgb(209 170 103 / 70%);
  color: rgb(209 170 103);
  font-weight: 600;
}

body.light_theme .agce-ft-close-modal-pct {
  background: #F5F5F5;
  border-color: #e5e7eb;
  color: #374151;
}

body.light_theme .agce-ft-close-modal-pct.is-active {
  background: rgb(209 170 103 / 10%);
  border-color: #d1aa67;
  color: #d1aa67;
}

.agce-ft-close-modal-summary {
  background: rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
}

body.light_theme .agce-ft-close-modal-summary {
  background: #f9fafb;
}

.agce-ft-close-modal-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.agce-ft-close-modal-summary-row+.agce-ft-close-modal-summary-row {
  margin-top: 8px;
}

.agce-ft-close-modal-summary-row>span:first-child {
  color: #9ca3af;
}

.agce-ft-close-modal-summary-row>span:last-child {
  color: #fff;
  font-weight: 500;
  text-align: right;
}

body.light_theme .agce-ft-close-modal-summary-row>span:last-child {
  color: #111827;
}

/* Match Borrow/Repay amount field: style.css only targets input[type=number] */
body:not(.light_theme) .margin-modal-container .modern-margin-form .price_max_total {
  background-color: #2B313C !important;
  border: 1px solid transparent !important;
  border-radius: 8px !important;
  padding: 4px 12px !important;
}

body.light_theme .margin-modal-container .modern-margin-form .price_max_total {
  background-color: #F5F5F5 !important;
  border: 1px solid #EAECEF !important;
  border-radius: 8px !important;
  padding: 4px 12px !important;
  color: #1E2329;
}

.margin-modal-container .modern-margin-form .price_max_total.is-error {
  border-color: #f6465d !important;
}

.margin-modal-container .modern-margin-form .price_max_total input[type="text"] {
  padding: 10px 18px;
  font-size: 13px;
  background-color: transparent;
  border: none;
  outline: none;
  width: 90%;
  color: #fff;
  font-weight: 500;
}

body.light_theme .margin-modal-container .modern-margin-form .price_max_total input[type="text"] {
  color: #1E2329;
}

.margin-modal-container .modern-margin-form .price_max_total input[type="text"]::placeholder {
  color: #9ca3af;
  opacity: 1;
}

.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--long,
.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--short {
  background-color: #d1aa67;
  color: #040404;
}

.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--long:hover:not(:disabled),
.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--short:hover:not(:disabled),
.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--long:focus:not(:disabled),
.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--short:focus:not(:disabled) {
  background-color: #d1aa67;
  color: #040404;
}

@media (max-width: 480px) {
  .agce-ft-close-modal-dialog {
    max-width: 100% !important;
    width: calc(100% - 24px);
    margin: 0.75rem auto;
  }

  .agce-ft-close-modal-pct {
    padding: 10px 0;
    font-size: 12px;
  }
}

.trade_summary_table_lft .spot_orders_table thead th.yellowcolor {
  color: #f3bb2b;
}

/* Futures position PnL — applied on inner elements to beat table td color rules */
.agce-ft-pnl--profit {
  color: #0ecb81 !important;
}

.agce-ft-pnl--loss {
  color: #f6465d !important;
}

.trade_summary_table_lft .spot_orders_table tbody td .agce-ft-pnl--profit,
.trade_summary_table_lft .spot_orders_table tbody td.agce-ft-pnl--profit,
.trade_summary_table_lft .so-mobileCard__row .agce-ft-pnl--profit,
.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--profit {
  color: #0ecb81 !important;
}

.trade_summary_table_lft .spot_orders_table tbody td .agce-ft-pnl--loss,
.trade_summary_table_lft .spot_orders_table tbody td.agce-ft-pnl--loss,
.trade_summary_table_lft .so-mobileCard__row .agce-ft-pnl--loss,
.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--loss {
  color: #f6465d !important;
}

@media (max-width: 1200px) {

  .order_history_mobile_view,
  .so-mobile,
  .twomobile {
    display: block !important;
  }

}


@media (max-width: 580px) {
  .agcx-ft-modal-panel--avg .agcx-ft-calc-grid {
    grid-template-columns: 1fr;
  }
}

.trade_fee_row_new {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 5px 0px;
  padding: 0 4px;
  font-family: "Inter", sans-serif;
}

.fee_hover_container {
  position: relative;
  display: flex;
  align-items: center;
}

.fee_trigger_wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.fee_badge_v0 {
  background: #f0f1f2;
  color: #5e6673;
  font-size: 11px;
  font-weight: 700;
  font-style: italic;
  padding: 1px 6px;
  border-radius: 10px;
  line-height: 1.2;
}

.fee_info_icon {
  color: #94a3b8;
  font-size: 14px;
}

.fee_separator {
  color: #e2e8f0;
  margin: 0 4px;
  font-weight: 300;
}

.fee_text {
  font-size: 12px;
  color: #fff;
  font-weight: 400;
  white-space: nowrap;
}

body.light_theme .fee_text {
  color: #1e2329;
}

.fee_detail_popup {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 10px;
  width: 280px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 16px;
  display: none;
  z-index: 100;
}

.fee_detail_popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 20px;
  background: transparent;
}

.fee_hover_container:hover .fee_detail_popup {
  display: block;
}

.fee_popup_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.fee_popup_title {
  font-size: 16px;
  font-weight: 500;
  color: #1e2329;
  border-bottom: 1px dotted #bcbcbc;
  padding-bottom: 2px;
}

.fee_popup_header_right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fee_badge_v0--small {
  font-size: 10px;
}

.fee_level_up_link {
  font-size: 13px;
  color: #0f0f0f;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
}

.fee_popup_rate_row {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 12px 0;
  margin-bottom: 8px;
}

.fee_popup_rate_item {
  display: flex;
  align-items: center;
}

.fee_popup_rate_label {
  font-size: 11px;
  color: #707a8a;
}

.fee_popup_rate_val {
  font-size: 16px;
  font-weight: 700;
  color: #1e2329;
}

.fee_popup_divider {
  color: #e2e8f0;
  margin: 0 4px;
}

.fee_pay_points_btn {
  background: #f0f1f2;
  color: #1e2329;
  border: none;
  padding: 4px 9px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 16px;
  width: auto;
  display: inline-block;
}

.fee_popup_footer {
  font-size: 12px;
  color: #848e9c;
  line-height: 1.5;
  border-top: 1px solid #f0f1f2;
  padding-top: 12px;
}

.dark-mode .fee_badge_v0 {
  background: #2b3139;
  color: #848e9c;
}

.dark-mode .fee_text {
  color: #eaecef;
}

.dark-mode .fee_separator {
  color: #334155;
}

.dark-mode .fee_detail_popup {
  background: #1e2329;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.dark-mode .fee_popup_title,
.dark-mode .fee_popup_rate_val {
  color: #eaecef;
}

.dark-mode .fee_popup_rate_row {
  background: transparent;
}

.dark-mode .fee_pay_points_btn {
  background: #2b3139;
  color: #eaecef;
}

.dark-mode .fee_popup_footer,
.dark-mode .fee_popup_header {
  border-color: #2b3139;
}

@media screen and (max-width: 1200px) {

  .assets_right.agce-ft-acct-rail {
    min-width: 100%;
    max-width: 100%;
  }

}

@media screen and (max-width: 991px) {

  .order_history_mobile_view,
  .so-mobile,
  .twomobile {
    display: block !important;
  }

  button.agce-margin-filter-toggle-btn.agce-futures-filter-toggle-btn {
    margin-left: 12px;
  }

  .agce-futures-points-card {
    margin-bottom: 20px;
  }

  .trade_fee_row_new {
    margin-top: 0px;
  }
}

/* ==========================================================================
   Dark Theme (Default) Overrides for Calculator & Contract Unit Modals
   ========================================================================== */

body:not(.light_theme) .agcx-ft-modal-backdrop {
  background: rgb(0 0 0 / 60%);
}

body:not(.light_theme) .agcx-ft-modal-panel {
  background: #1a1a1a69;
  border: 1px solid rgb(255 255 255 / 3%);
  color: #ffffff;
  box-shadow: 0 18px 48px rgb(0 0 0 / 70%);
}

body:not(.light_theme) .agcx-ft-modal-head {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .agcx-ft-modal-title {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-modal-close {
  color: #9aa0a6;
}

body:not(.light_theme) .agcx-ft-modal-close:hover {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-tabs-wrapper {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .agcx-ft-calc-tab-arrow {
  background: #111214;
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-tab-arrow.left {
  background: linear-gradient(to right, #111214 70%, rgba(17, 18, 20, 0));
}

body:not(.light_theme) .agcx-ft-calc-tab-arrow.right {
  background: linear-gradient(to left, #111214 70%, rgba(17, 18, 20, 0));
}

body:not(.light_theme) .agcx-ft-calc-tab-arrow:hover {
  color: #2563eb;
}

body:not(.light_theme) .agcx-ft-calc-tab {
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-calc-tab:before {
  background: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-tab.is-active {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-longshort button {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.12);
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-calc-longshort button.is-on:first-child {
  background: #00c087;
  border-color: #00c087;
  color: #fff;
}

body:not(.light_theme) .agcx-ft-calc-longshort button:last-child.is-on {
  background: #ff3b30;
  border-color: #ff3b30;
  color: #fff;
}

body:not(.light_theme) .agcx-ft-calc-field {
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-calc-select,
body:not(.light_theme) .agcx-ft-calc-col.agcx-ft-calc-col--form .agcx-ft-calc-select {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-input {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.12);
}

body:not(.light_theme) .agcx-ft-calc-input:focus-within {
  border-color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-input input {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-input span {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-results-card {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .agcx-ft-calc-out-row span:first-child {
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-calc-out-row span:last-child {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-liq-note {
  color: #64748b;
}

body:not(.light_theme) .agcx-ft-calc-avg-head {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-avg-row:hover {
  background: rgba(255, 255, 255, 0.05);
}

body:not(.light_theme) .avg-no {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-avg-delete:hover {
  background: rgba(239, 68, 68, 0.2);
}

body:not(.light_theme) .agcx-ft-calc-add-btn {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.12);
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-calc-add-btn:hover {
  background: #2b313c;
  color: #ffffff;
  border-color: #ffffff;
}

body:not(.light_theme) .agcx-ft-calc-note {
  background: #1e2329;
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-calc-note a {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-btn--primary {
  background: #2b313c;
  color: #8e9299;
}

body:not(.light_theme) .agcx-ft-btn--primary.is-active,
body:not(.light_theme) .agcx-ft-btn--primary:not(:disabled) {
  background: #d1aa67;
  color: #0f172a;
}

body:not(.light_theme) .agcx-ft-btn--primary:disabled {
  background: #2b313c;
  color: #8e9299;
  opacity: 0.6;
}

body:not(.light_theme) .agcx-ft-contract-card {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.12);
}

body:not(.light_theme) .agcx-ft-contract-card.is-selected {
  border-color: #ffffff;
  background: #2b313c;
}

body:not(.light_theme) .agcx-ft-contract-card__title {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-contract-card__desc {
  color: #94a3b8;
}

/* ==========================================================================
   Dark Theme (Default) Overrides for Funds Transfer Modal
   ========================================================================== */

body:not(.light_theme) .agcx-ft-transfer-banner {
  background: #1e23298c;
  color: #ffffff;
  border: 1px solid #e4e4e407;
}

body:not(.light_theme) .agcx-ft-transfer-field label {
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-transfer-box {
  background: #1e23298c;
  color: #ffffff;
  border: 1px solid #e4e4e407;
}

body:not(.light_theme) .agcx-ft-transfer-box.is-select.is-active {
  border-color: #ffffff14;
}

body:not(.light_theme) .agcx-ft-transfer-dropdown {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5);
}

body:not(.light_theme) .agcx-ft-transfer-dropdown-item {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-transfer-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

body:not(.light_theme) .agcx-ft-transfer-dropdown-item.is-selected {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

body:not(.light_theme) .agcx-ft-transfer-dropdown-item .item-action {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-quick-coin {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-quick-coin-radio {
  border-color: rgba(255, 255, 255, 0.3);
  background: #1e2329;
}

body:not(.light_theme) .agcx-ft-quick-coin-radio.is-checked {
  border-color: #ffffff;
}

body:not(.light_theme) .agcx-ft-quick-coin-radio.is-checked::after {
  background: #ffffff;
}

body:not(.light_theme) .agcx-ft-transfer-input-wrap {
  background: #1e23298c;
  color: #ffffff;
  border: 1px solid #e4e4e407;
}

body:not(.light_theme) .agcx-ft-transfer-input-wrap:focus-within {
  border-color: #ffffff;
}

body:not(.light_theme) .agcx-ft-transfer-input-wrap input {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-transfer-input-wrap .input-suffix span {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-transfer-input-wrap .input-suffix .divider {
  background: rgba(255, 255, 255, 0.12);
}

body:not(.light_theme) .agcx-ft-transfer-input-wrap .all-btn {
  color: #D1AA67;
}

body:not(.light_theme) .agcx-ft-transfer-avail {
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-btn--ghost {
  background: #2b313c;
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.1);
}

body:not(.light_theme) .agcx-ft-coin-search input {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.03);
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-coin-search i {
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-coin-item {
  color: #ffffff;
}

body:not(.light_theme) .agcx-ft-coin-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

body:not(.light_theme) .coin-short {
  color: #ffffff;
}

body:not(.light_theme) .coin-full {
  color: #94a3b8;
}

body:not(.light_theme) .agcx-ft-coin-item .ri-check-line {
  color: #ffffff !important;
}

body:not(.light_theme) .agcx-ft-transfer-swap:hover {
  border-color: #ffffff;
  background: rgba(255, 255, 255, 0.05);
}

/* ==========================================================================
   AGCX Custom Filter Select Styles (Replaces default select dropdown popup)
   ========================================================================== */

.agce-custom-select-container {
  position: relative;
  width: auto;
  min-width: 95px;
  display: inline-block;
  margin-right: 6px;
  margin-bottom: 0;
  vertical-align: middle;
}

.agce-custom-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 30px;
  padding: 0 10px;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 4px;
  color: #eaecef;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  box-sizing: border-box;
  transition: border-color 0.2s, background-color 0.2s;
  gap: 8px;
  white-space: nowrap;
}

body.light_theme .agce-custom-select-trigger {
  background: #f6f6f7;
  border: 1px solid #cbd5e1;
  color: #1e2329;
}

/* .agce-custom-select-trigger:focus,
.agce-custom-select-trigger:hover {
  border-color: #d1aa67;
} */

.agce-custom-select-trigger i {
  font-size: 14px;
  transition: transform 0.2s ease;
  color: #848e9c;
}

.agce-custom-select-trigger i.open {
  transform: rotate(180deg);
}

.agce-custom-select-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  width: max-content;
  max-width: 200px;
  max-height: 220px;
  overflow-y: auto;
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 6px;
  z-index: 100000;
  padding: 4px 0;
  margin: 0;
  list-style: none;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
}

body.light_theme .agce-custom-select-options {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
}

.agce-custom-select-option {
  padding: 8px 14px;
  font-size: 12px;
  color: #eaecef;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s, color 0.15s;
  white-space: nowrap;
}

body.light_theme .agce-custom-select-option {
  color: #1e2329;
}

.agce-custom-select-option:hover {
  background: #2b3139;
  color: #d1aa67;
}

body.light_theme .agce-custom-select-option:hover {
  background: #f1f5f9;
  color: #d1aa67;
}

.agce-custom-select-option.selected {
  background: rgba(209, 170, 103, 0.15);
  color: #d1aa67;
  font-weight: 600;
}

body.light_theme .agce-custom-select-option.selected {
  background: rgba(209, 170, 103, 0.1);
  color: #d1aa67;
  font-weight: 600;
}

/* Scrollbar customization for custom dropdown list */
.agce-custom-select-options::-webkit-scrollbar {
  width: 4px;
}

.agce-custom-select-options::-webkit-scrollbar-track {
  background: transparent;
}

.agce-custom-select-options::-webkit-scrollbar-thumb {
  background: #474f59;
  border-radius: 4px;
}

body.light_theme .agce-custom-select-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
}

/* Mobile popup filter content adjustments */
.agce-margin-filter-popup-content .agce-custom-select-container {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 12px;
}

.agce-margin-filter-popup-content .agce-custom-select-trigger {
  height: 38px;
  font-size: 13px;
  padding: 0 12px;
  border-radius: 8px;
}

/* Unique styling for Futures Conditional Tab USDT Suffix / Field */
.futures_conditional_usdt_suffix {
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
}

.futures_conditional_field_wrap {
  position: relative;
}

/* —— Futures margin mode modal (redesign) —— */
.agce-ft-mm-backdrop {
  z-index: 1050;
}

.agce-ft-mm-dialog {
  max-width: 380px !important;
  width: calc(100% - 32px);
  margin: 1rem auto;
}

.agce-ft-mm-content {
  border: none !important;
  border-radius: 18px !important;
  overflow: hidden;
  background: rgb(30 35 41 / 2%) !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);
}

body.light_theme .agce-ft-mm-content {
  background: rgb(255 255 255 / 20%) !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.agce-ft-mm-body {
  padding: 24px;
}

.agce-ft-mm-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.agce-ft-mm-title {
  margin: 0 0 4px;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.25;
  color: #eaecef;
}

body.light_theme .agce-ft-mm-title {
  color: #14161a;
}

.agce-ft-mm-subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.4;
  color: #848e9c;
}

body.light_theme .agce-ft-mm-subtitle {
  color: #9a9da3;
}

.agce-ft-mm-close {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.06);
  color: #848e9c;
  font-size: 16px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

body.light_theme .agce-ft-mm-close {
  background: #f2f3f5;
  color: #7a7f8a;
}

.agce-ft-mm-close:hover {
  color: #eaecef;
}

body.light_theme .agce-ft-mm-close:hover {
  color: #14161a;
}

.agce-ft-mm-segment {
  position: relative;
  display: flex;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 4px;
  margin-bottom: 18px;
}

body.light_theme .agce-ft-mm-segment {
  background: #f2f3f5;
}

.agce-ft-mm-segment__thumb {
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 8px);
  background: #eaecef;
  border-radius: 9px;
  transition: transform 0.22s ease;
  pointer-events: none;
}

body.light_theme .agce-ft-mm-segment__thumb {
  background: #14161a;
}

.agce-ft-mm-segment__thumb.is-isolated {
  transform: translateX(100%);
}

.agce-ft-mm-segment__btn {
  flex: 1 1;
  position: relative;
  z-index: 1;
  background: transparent !important;
  border: none !important;
  border-bottom: none !important;
  border-radius: 9px;
  padding: 11px 0 !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #848e9c !important;
  cursor: pointer;
}

.agce-ft-mm-segment__btn:before {
  display: none !important;
}

body.light_theme .agce-ft-mm-segment__btn {
  color: #9a9da3 !important;
}

.agce-ft-mm-segment__btn.is-active {
  color: #1e2329 !important;
}

body.light_theme .agce-ft-mm-segment__btn.is-active {
  color: #ffffff !important;
}

.agce-ft-mm-desc {
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  min-height: 110px;
}

body.light_theme .agce-ft-mm-desc {
  background: #f7f8f9;
}

.agce-ft-mm-desc p {
  margin: 0;
  font-size: 13px;
  line-height: 1.65;
  color: #b7bdc6;
}

body.light_theme .agce-ft-mm-desc p {
  color: #4d515a;
}

.agce-ft-mm-warn {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  background: rgba(246, 70, 93, 0.12);
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 18px;
}

body.light_theme .agce-ft-mm-warn {
  background: #fdf1f1;
}

.agce-ft-mm-warn__icon {
  color: #f6465d;
  font-size: 15px;
  line-height: 1.4;
  flex-shrink: 0;
}

body.light_theme .agce-ft-mm-warn__icon {
  color: #a32d2d;
}

.agce-ft-mm-warn p {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #f6465d;
}

body.light_theme .agce-ft-mm-warn p {
  color: #a32d2d;
}

/* ── Funding (Xh) / Countdown ticker + hover/click popup ─────────────────── */
.agcx-ft-funding-ticker {
  position: relative;
}

.agcx-ft-funding-ticker__trigger {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  font: inherit;
}

.agcx-ft-funding-ticker__label {
  cursor: pointer;
  border-bottom: 1px dotted rgba(255, 255, 255, 0.35);
  width: -moz-fit-content;
  width: fit-content;
}

body.light_theme .agcx-ft-funding-ticker__label {
  border-bottom-color: rgba(0, 0, 0, 0.28);
}

.agcx-ft-funding-ticker__value {
  display: flex;
  align-items: baseline;
  gap: 0;
  white-space: nowrap;
}

.agcx-ft-funding-ticker__rate {
  color: #d1aa67;
}

.agcx-ft-funding-ticker__sep,
.agcx-ft-funding-ticker__countdown {
  color: inherit;
}

.agcx-ft-funding-popup {
  width: min(360px, calc(100vw - 16px));
  padding: 14px 14px 12px;
  border-radius: 8px;
  background: #1e2329;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45);
  white-space: normal;
  pointer-events: auto;
}

.agcx-ft-funding-popup--portal {
  position: fixed;
  z-index: 10050;
}

body.light_theme .agcx-ft-funding-popup {
  background: #ffffff;
  border-color: #eaecef;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.agcx-ft-funding-popup__intro {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
  color: #b7bdc6;
}

body.light_theme .agcx-ft-funding-popup__intro {
  color: #707a8a;
}

.agcx-ft-funding-popup__rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.agcx-ft-funding-popup__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  font-size: 12px;
  line-height: 1.4;
}

.agcx-ft-funding-popup__key {
  color: #848e9c;
  flex: 1 1 auto;
}

body.light_theme .agcx-ft-funding-popup__key {
  color: #707a8a;
}

.agcx-ft-funding-popup__val {
  color: #eaecef;
  text-align: right;
  flex: 0 1 auto;
  font-variant-numeric: tabular-nums;
}

body.light_theme .agcx-ft-funding-popup__val {
  color: #1e2329;
}

.agcx-ft-funding-popup__payee {
  color: #d1aa67;
  font-weight: 600;
}

.agcx-ft-funding-ticker__label-short {
  display: none;
}

/* Desktop: keep Funding after Last/Change, before High/Low/Vol */
@media screen and (min-width: 992px) {
  .agcx-ft-ticker-stats {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
  }

  .agcx-ft-ticker-last {
    order: 1;
  }

  .agcx-ft-ticker-mark {
    order: 2;
  }

  .agcx-ft-ticker-index {
    order: 3;
  }

  .agcx-ft-ticker-change {
    order: 4;
  }

  .agcx-ft-funding-ticker {
    order: 5;
  }

  .agcx-ft-ticker-high {
    order: 6;
  }

  .agcx-ft-ticker-low {
    order: 7;
  }

  .agcx-ft-ticker-vol-base {
    order: 8;
  }

  .agcx-ft-ticker-vol-quote {
    order: 9;
  }

  .agcx-ft-funding-ticker__label-full {
    display: inline;
  }

  .agcx-ft-funding-ticker__label-short {
    display: none;
  }
}

@media (max-width: 767px) {
  .agcx-ft-batch-drawer-panel {
    width: 100%;
    border-radius: 16px 0 0 0;
    max-width: 85%;
  }

  .agce-ft-mm-confirm {
    padding: 10px 0 !important;
    font-size: 14px !important;
  }


  .agce-ft-mm-segment__btn {
    padding: 9px 0 !important;
    font-size: 13px !important;
  }

  .agcx-ft-trade-info-item {
    font-size: 12px;
  }

  .agce-margin-lvg-step-row button {
    font-size: 16px;
  }

  .agce-margin-lvg-step-val {
    font-size: 14px;
    font-weight: 500;
  }

  .agcx-ft-batch-lvg-slider-wrap {
    padding-bottom: 6px;
  }

}

@media screen and (max-width: 991.98px) {

  /* Binance mobile: 2×2 High/Low/Vol, Funding full-width underneath */
  .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS.agcx-ft-ticker-stats {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    row-gap: 6px;
    align-items: start !important;
    width: 100%;
  }

  .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS.agcx-ft-ticker-stats>.headline_leftItem__7BFYq {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
    gap: 2px;
    width: 100%;
    min-width: 0;
    margin-inline-start: 0 !important;
    padding: 0;
  }

  .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS.agcx-ft-ticker-stats>.headline_leftItem__7BFYq .headline_withBorder__a6ZD2 {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    font-weight: 200;
    font-size: 10px;
    line-height: 12px;
    text-align: start;
    margin: 0;
    opacity: 0.75;
  }

  .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS.agcx-ft-ticker-stats>.headline_leftItem__7BFYq .headline_title__x1csO {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    font-size: 12px;
    line-height: 16px;
    text-align: start !important;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .headline_left__lBBPY .agcx-ft-funding-ticker.headline_leftItem__7BFYq {
    margin-top: 4px;
    overflow: visible;
  }

  .headline_left__lBBPY .agcx-ft-funding-ticker .agcx-ft-funding-ticker__trigger {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2px;
    width: 100%;
    min-width: 0;
  }

  .headline_left__lBBPY .agcx-ft-funding-ticker .agcx-ft-funding-ticker__label {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    font-size: 10px;
    line-height: 12px;
    text-align: start;
    opacity: 0.75;
    border-bottom: 1px dotted rgba(255, 255, 255, 0.4);
  }

  body.light_theme .headline_left__lBBPY .agcx-ft-funding-ticker .agcx-ft-funding-ticker__label {
    border-bottom-color: rgba(0, 0, 0, 0.28);
  }

  .agcx-ft-funding-ticker__label-full {
    display: none;
  }

  .agcx-ft-funding-ticker__label-short {
    display: inline;
    font-weight: 300;
  }

  .headline_left__lBBPY .agcx-ft-funding-ticker .agcx-ft-funding-ticker__value {
    display: flex;
    flex-wrap: nowrap;
    align-items: baseline;
    justify-content: flex-start;
    gap: 0;
    width: 100%;
    font-size: 12px;
    line-height: 16px;
    text-align: left !important;
    white-space: nowrap;
  }

  .agcx-ft-funding-ticker__countdown {
    color: inherit;
    opacity: 0.95;
  }

  .agcx-ft-funding-popup--portal {
    max-height: min(70vh, 420px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .agcx-ft-funding-popup__row {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .agcx-ft-funding-popup__val {
    text-align: left;
  }
}

.agce-ft-mm-defaults {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  padding: 12px 2px;
  margin-bottom: 18px;
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0;
  background: transparent !important;
  cursor: pointer;
  text-align: left;
}

body.light_theme .agce-ft-mm-defaults {
  border-top-color: #ececee;
}

.agce-ft-mm-defaults:before {
  display: none !important;
}

.agce-ft-mm-defaults>span:first-child {
  font-size: 13.5px;
  font-weight: 600;
  color: #eaecef;
}

body.light_theme .agce-ft-mm-defaults>span:first-child {
  color: #14161a;
}

.agce-ft-mm-defaults__trail {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #848e9c;
  white-space: nowrap;
}

body.light_theme .agce-ft-mm-defaults__trail {
  color: #9a9da3;
}

.agce-ft-mm-confirm {
  width: 100%;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 0 !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  background: #d1aa67 !important;
  color: #1e2329 !important;
  cursor: pointer;
}

.agce-ft-mm-confirm:before {
  display: none !important;
}

.agce-ft-mm-confirm:hover:not(:disabled) {
  filter: brightness(1.05);
}

.agce-ft-mm-confirm:disabled {
  background: rgba(255, 255, 255, 0.08) !important;
  color: #5e6673 !important;
  cursor: not-allowed;
  filter: none;
}

body.light_theme .agce-ft-mm-confirm:not(:disabled) {
  background: #d1aa67 !important;
  color: #14161a !important;
}

body.light_theme .agce-ft-mm-confirm:disabled {
  background: #e7e9ec !important;
  color: #a9adb5 !important;
}

button.agce-margin-leverage-trigger-btn1 {
  cursor: pointer !important;
}

/* Adjust Leverage foot — overrides shared margin/margin.css (same class names, white Confirm) */
.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--ghost {
  flex: 0.65 1 !important;
  max-width: 34%;
}

.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {
  flex: 2.1 1 !important;
  background: #d1aa67 !important;
  color: #1e2329 !important;
}

.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary:hover {
  filter: brightness(1.05);
  background: #d1aa67 !important;
}

body:not(.light_theme) .agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {
  background: #d1aa67 !important;
  color: #1e2329 !important;
}

body.light_theme .agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {
  background: #d1aa67 !important;
  color: #14161a !important;
}

/* ── Futures trade load skeletons ─────────────────────────────────────────── */
.agcx-ft-ob-skel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 10px 8px;
  min-height: 160px;
  box-sizing: border-box;
}

.agcx-ft-ob-skel__row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  width: 100%;
}

.agcx-ft-ob-skel__cell {
  display: block;
  height: 10px;
  min-height: 10px;
  min-width: 0;
  width: 100%;
  border-radius: 3px;
}

.agcx-ft-buysell-skel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 12px 12px 16px;
  min-height: 100%;
  width: 100%;
  box-sizing: border-box;
  flex: 1 1 auto;
}

/* Stretch skeleton to the full buy/sell card height (aligned with order book column). */
.trade_card.buysell_card.buysell_two {
  display: flex;
  flex-direction: column;
}

.trade_card.buysell_card.buysell_two>.agcx-ft-buysell-skel {
  flex: 1 1 auto;
  min-height: 520px;
}

.agcx-ft-buysell-skel__top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agcx-ft-buysell-skel__chip {
  display: block;
  height: 30px;
  width: 108px;
  min-width: 88px;
  border-radius: 8px;
}

.agcx-ft-buysell-skel__modes {
  display: flex;
  align-items: center;
  gap: 10px;
}

.agcx-ft-buysell-skel__mode {
  display: block;
  height: 22px;
  width: 64px;
  min-width: 52px;
  border-radius: 4px;
}

.agcx-ft-buysell-skel__info {
  display: block;
  height: 16px;
  width: 16px;
  min-width: 16px;
  margin-left: auto;
  border-radius: 50%;
}

.agcx-ft-buysell-skel__split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  flex: 1 1 auto;
  align-items: stretch;
  min-height: 0;
}

.agcx-ft-buysell-skel__col {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.agcx-ft-buysell-skel__avail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.agcx-ft-buysell-skel__label {
  display: block;
  height: 12px;
  width: 72px;
  min-width: 56px;
  border-radius: 4px;
}

.agcx-ft-buysell-skel__val {
  display: block;
  height: 12px;
  width: 96px;
  min-width: 64px;
  border-radius: 4px;
}

.agcx-ft-buysell-skel__field {
  display: block;
  height: 42px;
  width: 100%;
  min-width: 0;
  border-radius: 8px;
}

.agcx-ft-buysell-skel__slider {
  display: block;
  height: 10px;
  width: 100%;
  min-width: 0;
  margin-top: 2px;
  border-radius: 6px;
}

.agcx-ft-buysell-skel__ticks {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  margin-top: -2px;
}

.agcx-ft-buysell-skel__tick {
  display: block;
  height: 8px;
  width: 18px;
  min-width: 14px;
  border-radius: 3px;
}

.agcx-ft-buysell-skel__check {
  display: block;
  height: 14px;
  width: 88px;
  min-width: 64px;
  border-radius: 4px;
}

.agcx-ft-buysell-skel__cta {
  display: block;
  height: 40px;
  width: 100%;
  min-width: 0;
  margin-top: auto;
  border-radius: 8px;
}

.agcx-ft-buysell-skel__fee {
  display: flex;
  align-items: center;
  padding-top: 4px;
}

.agcx-ft-buysell-skel__fee-line {
  display: block;
  height: 12px;
  width: 70%;
  max-width: 280px;
  min-width: 140px;
  border-radius: 4px;
}

@media screen and (max-width: 991.98px) {
  .agcx-ft-buysell-skel__split {
    grid-template-columns: 1fr;
  }

  .agcx-ft-buysell-skel__col--sell {
    display: none;
  }
}

.agcx-ft-acct-skel__title {
  display: block;
  height: 18px;
  width: 88px;
  min-width: 88px;
  border-radius: 4px;
}

.agcx-ft-acct-skel__section-title {
  display: block;
  height: 12px;
  width: 96px;
  min-width: 96px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.agcx-ft-acct-skel__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.agcx-ft-acct-skel__label {
  display: block;
  height: 12px;
  width: 110px;
  min-width: 72px;
  border-radius: 4px;
}

.agcx-ft-acct-skel__val {
  display: block;
  height: 12px;
  width: 88px;
  min-width: 64px;
  border-radius: 4px;
}

.agcx-ft-acct-skel__actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.agcx-ft-acct-skel__action {
  display: block;
  height: 32px;
  flex: 1 1;
  min-width: 0;
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/futures_trade/futures_trade_extras.css"],"names":[],"mappings":"AAAA,qFAAqF;;AAErF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,gCAAwB;UAAxB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,MAAM;EACN,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,uEAAuE;AACzE;;AAEA;EACE,QAAQ;EACR,sEAAsE;AACxE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;EACV,QAAQ;EACR,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,8EAA8E;EAC9E,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mCAAmC;EACnC,aAAa;EACb,wCAAwC;EACxC,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,4BAA4B;EAC5B,2BAA2B;EAC3B,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kDAAkD;EAClD,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gEAAgE;EAChE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EAET,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;;AAIA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,wEAAwE;EACxE,0BAA0B;EAC1B,uEAAuE;AACzE;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,uEAAuE;AACzE;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;;EAEE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,mFAAmF;EACnF,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;;GAEG;;AAEH;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;;GAGG;;AAEH;EACE,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;;;AAKA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;AAEF;;AAEA;;;EAGE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;;EAIA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;;;EAGE,wBAAwB;AAC1B;;;;AAIA,sDAAsD;AACtD;;;;;EAKE,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,gEAAgE;EAChE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,oCAAoC;EACpC,wCAAwC;EACxC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE;;;IAGE,yBAAyB;EAC3B;;AAEF;;;AAGA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE;IACE,eAAe;IACf,eAAe;EACjB;;AAEF;;AAEA;;EAEE;;;IAGE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,oDAAoD;EACpD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;EACE,eAAe;EACf,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mDAAmD;EACnD,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,iEAAiE;AACjE;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;;;EAGA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;AAEF;;AAEA;;EAEE,oEAAoE;EACpE;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,sCAAsC;IACtC,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,QAAQ;IACR,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,kDAAkD;EACpD;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;IAC3B,MAAM;IACN,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;EAC/C,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gGAAgG;AAChG;EACE,uBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA,wFAAwF;AACxF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/* Futures trade page — Contract unit + Calculator modals (not used on margin page) */\n\n.agcx-ft-modal-root {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  z-index: 99999999 !important;\n  background-color: #00000020;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.agcx-ft-modal-panel.agcx-ft-modal-panel--transfer {\n  backdrop-filter: inherit;\n}\n\nbody.light_theme .agcx-ft-modal-root {\n  background-color: #ffffff2e;\n}\n\n.agcx-ft-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  background: rgb(255 255 255 / 20%);\n}\n\n.agcx-ft-modal-panel {\n  position: relative;\n  width: 100%;\n  max-width: 420px;\n  max-height: min(92vh, 720px);\n  overflow: auto;\n  border-radius: 14px;\n  background: rgb(255 255 255 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.18);\n}\n\n.agcx-ft-modal-panel--calc {\n  max-width: 720px;\n}\n\n.agcx-ft-modal-panel--avg {\n  max-width: 820px;\n}\n\n.agcx-ft-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 32px 24px;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n  margin-bottom: 10px;\n}\n\n.agcx-ft-modal-title {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 600;\n  color: #202020;\n}\n\n.limit_buy_plus {\n  border: none;\n}\n\n.agcx-ft-modal-close {\n  border: 0;\n  background: transparent;\n  font-size: 22px;\n  line-height: 1;\n  color: #64748b;\n  cursor: pointer;\n  padding: 0px;\n}\n\n.agcx-ft-modal-body {\n  padding: 18px 32px 32px;\n}\n\n.agcx-ft-modal-foot {\n  padding: 0 18px 18px;\n}\n\n.agcx-ft-contract-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agcx-ft-contract-card {\n  text-align: left;\n  width: 100%;\n  border-radius: 12px;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  background: #fff;\n  padding: 12px 14px;\n  cursor: pointer;\n}\n\n.agcx-ft-modal-panel--contract {\n  max-width: 520px;\n}\n\n.agcx-ft-contract-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 12px 20px;\n}\n\n.agcx-ft-contract-card {\n  text-align: left;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: #fff;\n  padding: 16px 20px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.agcx-ft-contract-card.is-selected {\n  border-color: #0f172a;\n  border-width: 1px;\n  background: #fff;\n}\n\n.agcx-ft-contract-card__title {\n  font-weight: 600;\n  font-size: 16px;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.agcx-ft-contract-card__desc {\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.agcx-ft-modal-foot {\n  padding: 12px 20px 24px;\n}\n\n.agcx-ft-btn--primary {\n  width: 100%;\n  background: #f1f5f9;\n  border: none;\n  color: #94a3b8;\n  border-radius: 50px;\n  font-weight: 600;\n  height: 48px;\n  font-size: 15px;\n}\n\n.agcx-ft-btn--primary.is-active {\n  background: #0f172a;\n  color: #fff;\n}\n\n.agcx-ft-btn--primary:not(:disabled) {\n  background: #0f172a;\n  color: #fff;\n}\n\n.agcx-ft-btn--primary:disabled {\n  cursor: not-allowed;\n  opacity: 0.85;\n}\n\n.agcx-ft-btn--ghost {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.agcx-ft-btn--block {\n  width: 100%;\n  margin-top: 8px;\n}\n\n.agcx-ft-calc-tabs-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n.agcx-ft-calc-tabs {\n  display: flex;\n  gap: 0;\n  padding: 0 12px;\n  overflow-x: auto;\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* IE/Edge */\n  flex: 1;\n}\n\n.agcx-ft-calc-tabs::-webkit-scrollbar {\n  display: none;\n  /* Chrome/Safari/Webkit */\n}\n\n.agcx-ft-calc-tab-arrow {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 32px;\n  background: #fff;\n  border: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n  color: #0f172a;\n  font-size: 18px;\n  transition: opacity 0.2s;\n}\n\n.agcx-ft-calc-tab-arrow.left {\n  left: 0;\n  background: linear-gradient(to right, #fff 70%, rgba(255, 255, 255, 0));\n}\n\n.agcx-ft-calc-tab-arrow.right {\n  right: 0;\n  background: linear-gradient(to left, #fff 70%, rgba(255, 255, 255, 0));\n}\n\n.agcx-ft-calc-tab-arrow:hover {\n  color: #2563eb;\n}\n\n.agcx-ft-calc-tab {\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  padding: 12px 14px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  position: relative;\n  border-bottom: none;\n  margin-bottom: -1px;\n}\n\n.agcx-ft-calc-tab:before {\n  position: absolute;\n  width: 30%;\n  bottom: 0;\n  left: 0;\n  content: '';\n  opacity: 0;\n  right: 0;\n  margin: 0 auto;\n  height: 3px;\n  background: #0f172a;\n  transition: all 0.2s ease;\n}\n\n.agcx-ft-calc-tab.is-active:before {\n  opacity: 1;\n}\n\n.agcx-ft-calc-tab.is-active {\n  color: #0f172a;\n  border-bottom-color: #0f172a;\n}\n\n.agcx-ft-calc-body {\n  padding-top: 16px;\n}\n\n.agcx-ft-calc-grid {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr;\n  gap: 24px;\n}\n\n@media (max-width: 640px) {\n  .agcx-ft-calc-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.agcx-ft-calc-longshort {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.agcx-ft-calc-longshort button {\n  flex: 1 1;\n  border-radius: 8px;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  padding: 7px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  background: #f1f5f9;\n  color: #64748b;\n  transition: all 0.2s ease;\n}\n\n.agcx-ft-calc-longshort button.is-on:first-child {\n  background: #00c087;\n  border-color: #00c087;\n  color: #fff;\n}\n\n.agcx-ft-calc-longshort button.is-on:last-child {\n  background: #f1f5f9;\n  /* grey when not active, but the user screenshot shows grey for Short? Wait. */\n  border-color: rgba(15, 23, 42, 0.12);\n}\n\n.agcx-ft-calc-longshort button:last-child.is-on {\n  background: #ff3b30;\n  border-color: #ff3b30;\n  color: #fff;\n}\n\n.agcx-ft-calc-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 12px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.agcx-ft-calc-select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 14px;\n  outline: none;\n  color: #0f172a;\n}\n\n.agcx-ft-calc-input {\n  display: flex;\n  align-items: center;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  border-radius: 8px;\n  overflow: hidden;\n  background: #f8fafc;\n  transition: border-color 0.2s;\n}\n\n.agcx-ft-calc-input:focus-within {\n  border-color: #0f172a;\n}\n\n.agcx-ft-calc-input input {\n  flex: 1 1 auto;\n  border: 0;\n  background: transparent;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  outline: none;\n  min-width: 0;\n}\n\n.agcx-ft-calc-input span {\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0f172a;\n  white-space: nowrap;\n}\n\n.agcx-ft-calc-results-card {\n  background: #fff;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 12px;\n  padding: 16px;\n  height: 100%;\n  min-height: 240px;\n}\n\n.agcx-ft-calc-out-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n}\n\n.agcx-ft-calc-out-row:last-of-type {\n  border-bottom: 0;\n}\n\n.agcx-ft-calc-out-row span:first-child {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.agcx-ft-calc-out-row span:last-child {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.agcx-ft-calc-liq-note {\n  margin-top: auto;\n  font-size: 12px;\n  color: #94a3b8;\n  line-height: 1.4;\n  padding-top: 16px;\n}\n\n.agcx-ft-calc-avg-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.agcx-ft-calc-avg-head {\n  display: grid;\n  grid-template-columns: 28px 1fr 1fr 28px;\n  gap: 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  padding: 0 4px;\n  margin-bottom: 4px;\n}\n\n.agcx-ft-modal-panel--avg .agcx-ft-calc-grid {\n  grid-template-columns: 1.5fr 1fr;\n}\n\n.agcx-ft-calc-col.agcx-ft-calc-col--form .agcx-ft-calc-select {\n  box-shadow: none;\n  height: 42px;\n  background: #F6F6F7;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 500;\n  width: 100%;\n  /* backdrop-filter: blur(5px); */\n  /* border-radius: 4px !important; */\n  padding: 10px;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  border-radius: 8px !important;\n  overflow: hidden;\n  background: #f8fafc;\n  transition: border-color 0.2s;\n}\n\n.agcx-ft-calc-avg-row {\n  display: grid;\n  grid-template-columns: 28px 1fr 1fr 28px;\n  gap: 12px;\n  align-items: center;\n  padding: 4px;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n\n.agcx-ft-calc-avg-row:hover {\n  background: rgba(15, 23, 42, 0.02);\n}\n\n.avg-no {\n  font-weight: 600;\n  color: #0f172a;\n  text-align: left;\n  font-size: 14px;\n}\n\n.avg-action-col {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n}\n\n.agcx-ft-calc-avg-delete {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  background: transparent;\n  color: #ef4444;\n  cursor: pointer;\n  font-size: 18px;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n\n.agcx-ft-calc-avg-delete:hover {\n  background: #fee2e2;\n}\n\n.agcx-ft-calc-add-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  padding: 10px;\n  background: #f8fafc;\n  border: 1px dashed rgba(15, 23, 42, 0.12);\n  border-radius: 8px;\n  color: #64748b;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: all 0.2s;\n}\n\n.agcx-ft-calc-add-btn:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n  border-color: #0f172a;\n}\n\n.agcx-ft-calc-note {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  margin: 0 18px 18px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: #f1f5f9;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.agcx-ft-calc-note a {\n  color: #0f172a;\n  text-decoration: underline;\n  font-weight: 500;\n}\n\n.limit_buy_calc_btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  /* height: 32px; */\n  margin-left: 0px;\n  padding: 0px;\n  border: 0;\n  border-radius: 0px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.limit_buy_calc_btn:hover {\n  background: rgba(15, 23, 42, 0.06);\n}\n\n.limit_buy_calc_icon {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n  display: block;\n  filter: invert(1);\n}\n\nbody.light_theme .limit_buy_calc_icon {\n  filter: invert(0);\n}\n\n/* .limit_buy_calc_btn:hover {\n  background: rgba(15, 23, 42, 0.06);\n  color: #0f172a;\n} */\n\n.agcx-ft-amt-unit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  border: 0;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n  cursor: pointer;\n  padding: 4px 6px;\n}\n\n.agcx-ft-amt-unit-btn i {\n  font-size: 16px;\n  color: #64748b;\n}\n\n\n.spot_limit_dd_menu button {\n  font-weight: 500;\n}\n\n/* —— Batch adjust drawer (leverage + margin mode only; no pair picker) —— */\n.agcx-ft-batch-drawer-root {\n  position: fixed;\n  inset: 0;\n  z-index: 100000000;\n  pointer-events: none;\n}\n\n.agcx-ft-batch-drawer-root--open {\n  pointer-events: auto;\n}\n\n.agcx-ft-batch-drawer-backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.55);\n  opacity: 0;\n  transition: opacity 0.35s ease;\n}\n\n.agcx-ft-batch-drawer-root--open .agcx-ft-batch-drawer-backdrop {\n  opacity: 1;\n}\n\nbody.light_theme .agcx-ft-batch-drawer-backdrop {\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.agcx-ft-batch-drawer-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(100%, 420px);\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #1e2329;\n  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.45);\n  border-radius: 16px 0 0 16px;\n  transform: translateX(100%);\n  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);\n  overflow: hidden;\n}\n\nbody.light_theme .agcx-ft-batch-drawer-panel {\n  background: #ffffff;\n  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.12);\n}\n\n.agcx-ft-batch-drawer-root--open .agcx-ft-batch-drawer-panel {\n  transform: translateX(0);\n}\n\naside.agcx-ft-batch-drawer-panel header,\naside.agcx-ft-batch-drawer-panel footer {\n  background-color: transparent;\n}\n\n.agcx-ft-batch-drawer-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 12px 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n  background: #1e2329;\n}\n\nbody.light_theme .agcx-ft-batch-drawer-head {\n  border-bottom-color: #ececee;\n  background: #ffffff;\n}\n\n.agcx-ft-batch-drawer-title {\n  flex: 1 1 auto;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #eaecef;\n  text-align: left;\n}\n\nbody.light_theme .agcx-ft-batch-drawer-title {\n  color: #14161a;\n}\n\n.agcx-ft-batch-drawer-iconbtn {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  background: transparent;\n  color: #848e9c;\n  cursor: pointer;\n  border-radius: 10px;\n  font-size: 22px;\n}\n\n.agcx-ft-batch-drawer-iconbtn:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: #eaecef;\n}\n\nbody.light_theme .agcx-ft-batch-drawer-iconbtn {\n  color: #7a7f8a;\n}\n\nbody.light_theme .agcx-ft-batch-drawer-iconbtn:hover {\n  background: #f2f3f5;\n  color: #14161a;\n}\n\n.agcx-ft-batch-drawer-body {\n  flex: 1 1 auto;\n  overflow: auto;\n  padding: 16px 16px 8px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.agcx-ft-batch-drawer-foot {\n  flex-shrink: 0;\n  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background: #1e2329;\n}\n\nbody.light_theme .agcx-ft-batch-drawer-foot {\n  border-top-color: #ececee;\n  background: #ffffff;\n}\n\n.agcx-ft-batch-section {\n  margin-bottom: 8px;\n  padding-bottom: 18px;\n}\n\n.agcx-ft-batch-section+.agcx-ft-batch-section {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 18px;\n}\n\nbody.light_theme .agcx-ft-batch-section+.agcx-ft-batch-section {\n  border-top-color: #ececee;\n}\n\n.agcx-ft-batch-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 44px;\n}\n\n.agcx-ft-batch-row-text {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.agcx-ft-batch-row-label {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\nbody.light_theme .agcx-ft-batch-row-label {\n  color: #14161a;\n}\n\n.agcx-ft-batch-row-sub {\n  margin: 4px 0 0;\n  font-size: 12.5px;\n  line-height: 1.4;\n  color: #848e9c;\n}\n\nbody.light_theme .agcx-ft-batch-row-sub {\n  color: #9a9da3;\n}\n\n.agcx-ft-batch-switch {\n  position: relative;\n  width: 40px;\n  height: 22px;\n  border-radius: 999px;\n  border: 0;\n  padding: 0;\n  background: rgba(255, 255, 255, 0.12);\n  cursor: pointer;\n  transition: background 0.25s ease;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\nbody.light_theme .agcx-ft-batch-switch {\n  background: #e2e8f0;\n}\n\n.agcx-ft-batch-switch.is-on {\n  background: #d1aa67;\n}\n\n.agcx-ft-batch-switch-knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  transition: transform 0.25s ease;\n}\n\n.agcx-ft-batch-switch.is-on .agcx-ft-batch-switch-knob {\n  transform: translateX(18px);\n}\n\n.agcx-ft-batch-leverage-block {\n  margin-top: 14px;\n  margin-bottom: 4px;\n}\n\n.agcx-ft-batch-lvg-input-wrap {\n  display: flex;\n  align-items: stretch;\n  border: 1px solid rgba(15, 23, 42, 0.12);\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f8fafc;\n}\n\n.agcx-ft-batch-lvg-input {\n  flex: 1 1 auto;\n  border: 0;\n  padding: 12px 8px 12px 14px;\n  font-size: 16px;\n  font-weight: 600;\n  background: transparent;\n  min-width: 0;\n  outline: none;\n}\n\n.agcx-ft-batch-lvg-suffix {\n  display: flex;\n  align-items: center;\n  padding-right: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.agcx-ft-batch-lvg-stepper {\n  display: flex;\n  flex-direction: column;\n  border-left: 1px solid rgba(15, 23, 42, 0.08);\n  flex-shrink: 0;\n}\n\n.agcx-ft-batch-lvg-stepper button {\n  flex: 1;\n  min-height: 24px;\n  padding: 0 10px;\n  border: 0;\n  border-bottom: 1px solid #e0e0e0;\n  background: #fff;\n  cursor: pointer;\n  font-size: 10px;\n  line-height: 1;\n  color: #64748b;\n}\n\n.agcx-ft-batch-lvg-stepper button:hover {\n  background: #f1f5f9;\n}\n\n.agcx-ft-batch-lvg-slider-wrap {\n  position: relative;\n  margin-top: 20px;\n  padding-bottom: 28px;\n  --lvg-thumb-half: 9px;\n}\n\n.agce-ft-lvg-slider-rail {\n  position: relative;\n  margin: 0 var(--lvg-thumb-half);\n}\n\n.agcx-ft-batch-lvg-track-bg {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 10px;\n  height: 4px;\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.2);\n  pointer-events: none;\n}\n\nbody.light_theme .agcx-ft-batch-lvg-track-bg {\n  background: #e2e8f0;\n}\n\n.agcx-ft-batch-lvg-track-fill {\n  position: absolute;\n  left: 0;\n  top: 10px;\n  height: 4px;\n  border-radius: 2px;\n  background: #ffffff;\n  pointer-events: none;\n  z-index: 1;\n  transition: width 0.05s ease-out;\n}\n\nbody.light_theme .agcx-ft-batch-lvg-track-fill {\n  background: #0f172a;\n}\n\n.agcx-ft-batch-lvg-range {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: 24px;\n  margin: 0;\n  -webkit-appearance: none;\n  appearance: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.agcx-ft-batch-lvg-range::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #0f172a;\n  border: 2px solid #fff;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n  margin-top: -7px;\n}\n\n.agcx-ft-batch-lvg-range::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #0f172a;\n  border: 2px solid #fff;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n}\n\n.agcx-ft-batch-lvg-range::-webkit-slider-runnable-track {\n  height: 4px;\n  background: transparent;\n}\n\n.agcx-ft-batch-lvg-range::-moz-range-track {\n  height: 4px;\n  background: transparent;\n}\n\n.agcx-ft-batch-lvg-ticks {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n  padding: 0 2px;\n  font-size: 11px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n/* Leverage modal — − / value / + stepper + diamond tick marks */\n.agce-margin-lvg-slider-block {\n  margin-bottom: 16px;\n}\n\n.agce-margin-lvg-step-row {\n  display: flex;\n  align-items: stretch;\n  border: 1px solid #cbd5e10f;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #222325;\n  margin-bottom: 16px;\n}\n\nbody.light_theme .agce-margin-lvg-step-row {\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n}\n\n.agce-margin-lvg-step-row button {\n  flex: 0 0 48px;\n  border: 0;\n  background: #222325;\n  font-size: 22px;\n  line-height: 1.5;\n  color: #e6e6e6;\n  cursor: pointer;\n}\n\nbody.light_theme .agce-margin-lvg-step-row button {\n  background: #fff;\n  color: #334155;\n}\n\n.agce-margin-lvg-step-row button:first-child {\n  border-right: 1px solid #e2e8f01a;\n}\n\nbody.light_theme .agce-margin-lvg-step-row button:first-child {\n  border-right: 1px solid #e2e8f0;\n}\n\n.agce-margin-lvg-step-row button:last-child {\n  border-left: 1px solid #e2e8f01a;\n}\n\nbody.light_theme .agce-margin-lvg-step-row button:last-child {\n  border-left: 1px solid #e2e8f0;\n}\n\n.agce-margin-lvg-step-row button:hover {\n  opacity: 0.8;\n}\n\n.agce-margin-lvg-step-val {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\nbody.light_theme .agce-margin-lvg-step-val {\n  color: #0f172a;\n}\n\n.agce-ft-lvg-slider-ticks {\n  position: relative;\n  display: block;\n  height: 36px;\n  margin: 2px var(--lvg-thumb-half, 9px) 0;\n}\n\n.agce-ft-lvg-slider-ticks .agcx-ft-batch-lvg-tick {\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  font-size: 11px;\n  color: #94a3b8;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.agce-ft-lvg-slider-ticks .agcx-ft-batch-lvg-tick.is-active {\n  color: #b2b2b2;\n  font-weight: 700;\n}\n\nbody.light_theme .agce-ft-lvg-slider-ticks .agcx-ft-batch-lvg-tick.is-active {\n  color: #0f172a;\n}\n\n.agce-margin-lvg-tick-diamond {\n  display: block;\n  width: 8px;\n  height: 8px;\n  border: 2px solid #cbd5e1;\n  background: #fff;\n  transform: rotate(45deg);\n}\n\n.agce-ft-lvg-slider-ticks .agcx-ft-batch-lvg-tick.is-active .agce-margin-lvg-tick-diamond {\n  border-color: #0f172a;\n  border-width: 2px;\n}\n\n.agce-margin-lvg-notes {\n  margin: 0 0 12px;\n  padding-left: 0px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #bbbbbb;\n}\n\nbody.light_theme .agce-margin-lvg-notes {\n  color: #64748b;\n}\n\n.agce-margin-lvg-notes li {\n  margin-bottom: 8px;\n}\n\n.agce-margin-lvg-notes li:last-child {\n  margin-bottom: 0;\n}\n\n.agce-margin-lvg-notes a {\n  color: #c99400;\n  text-decoration: none;\n}\n\n.agce-margin-lvg-notes a:hover {\n  text-decoration: underline;\n}\n\n.agcx-ft-batch-mode-segment {\n  position: relative;\n  display: flex;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 12px;\n  padding: 4px;\n  margin-top: 14px;\n}\n\nbody.light_theme .agcx-ft-batch-mode-segment {\n  background: #f2f3f5;\n}\n\n.agcx-ft-batch-mode-segment__thumb {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: calc(50% - 4px);\n  height: calc(100% - 8px);\n  background: #eaecef;\n  border-radius: 9px;\n  transition: transform 0.22s ease;\n  pointer-events: none;\n  z-index: 0;\n}\n\nbody.light_theme .agcx-ft-batch-mode-segment__thumb {\n  background: #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.agcx-ft-batch-mode-segment__thumb.is-isolated {\n  transform: translateX(100%);\n}\n\n.agcx-ft-batch-mode-segment__btn {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  min-height: 40px;\n  border: 0;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 600;\n  color: #848e9c;\n  cursor: pointer;\n  border-radius: 9px;\n}\n\nbody.light_theme .agcx-ft-batch-mode-segment__btn {\n  color: #9a9da3;\n}\n\n.agcx-ft-batch-mode-segment__btn.is-active {\n  color: #1e2329;\n}\n\nbody.light_theme .agcx-ft-batch-mode-segment__btn.is-active {\n  color: #14161a;\n}\n\n.agcx-ft-batch-warn {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 8px 0 12px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: rgba(209, 170, 103, 0.12);\n  border: 1px solid rgba(209, 170, 103, 0.28);\n}\n\nbody.light_theme .agcx-ft-batch-warn {\n  background: rgba(209, 170, 103, 0.1);\n  border-color: rgba(209, 170, 103, 0.35);\n}\n\n.agcx-ft-batch-warn__icon {\n  flex-shrink: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #d1aa67;\n}\n\n.agcx-ft-batch-warn p {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: #c9b07a;\n}\n\nbody.light_theme .agcx-ft-batch-warn p {\n  color: #8a7340;\n}\n\n.agcx-ft-batch-confirm {\n  width: 100%;\n  min-height: 48px;\n  border: 0;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  background: #d1aa67;\n  color: #1e2329;\n  transition: filter 0.2s, opacity 0.2s;\n}\n\n.agcx-ft-batch-confirm:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n\n.agcx-ft-batch-confirm:disabled {\n  background: rgba(255, 255, 255, 0.08);\n  color: #5e6673;\n  cursor: not-allowed;\n  filter: none;\n}\n\nbody.light_theme .agcx-ft-batch-confirm:not(:disabled) {\n  background: #d1aa67;\n  color: #14161a;\n}\n\nbody.light_theme .agcx-ft-batch-confirm:disabled {\n  background: #e7e9ec;\n  color: #a9adb5;\n}\n\n\n\n.agcx-ft-modal-panel--transfer {\n  max-width: 712px;\n}\n\n.agcx-ft-transfer-body {\n  padding: 16px 24px 24px;\n}\n\n.agcx-ft-transfer-banner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  /* background: #fdfaf2; */\n  border: 1px solid #E4E4E4;\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin-bottom: 24px;\n  position: relative;\n}\n\n.agcx-ft-transfer-banner .banner-icon {\n  width: 47px;\n  /* height: 32px; */\n  flex-shrink: 0;\n}\n\n.agcx-ft-transfer-banner .banner-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.agcx-ft-transfer-banner .banner-text {\n  font-size: 14px;\n  color: #e5e5e5;\n  font-weight: 500;\n  flex: 1 1;\n  line-height: 1.4;\n}\n\nbody.light_theme .agcx-ft-transfer-banner .banner-text {\n  color: #101828;\n}\n\n.agcx-ft-transfer-banner .banner-close {\n  background: transparent;\n  border: 0;\n  color: #101828;\n  opacity: 0.7;\n  cursor: pointer;\n  padding: 4px;\n}\n\n.agcx-ft-transfer-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 5px;\n}\n\n.agcx-ft-transfer-field {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.agcx-ft-transfer-field label {\n  font-size: 18px;\n  font-weight: 500;\n  color: #303236;\n}\n\n.agcx-ft-transfer-box {\n  background: none;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 48px;\n}\n\n.agcx-ft-transfer-box.is-select {\n  cursor: pointer;\n}\n\n.agcx-ft-transfer-box.is-coin {\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.agcx-ft-transfer-box .coin-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.agcx-ft-transfer-box .coin-info img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.agcx-ft-transfer-swap {\n  width: 36px;\n  min-width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin-bottom: 0px;\n  transition: all 0.2s;\n}\n\n.agcx-ft-transfer-swap img {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.agcx-ft-transfer-swap:hover {\n  border-color: #0f172a;\n  background: #f8fafc;\n}\n\n\n.agcx-ft-transfer-input-wrap {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  border-radius: 12px;\n  padding: 0 16px;\n  transition: border-color 0.2s;\n}\n\n.agcx-ft-transfer-input-wrap:focus-within {\n  border-color: #0f172a;\n}\n\n.agcx-ft-transfer-input-wrap input {\n  flex: 1;\n  border: 0;\n  background: transparent;\n  padding: 14px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n  outline: none;\n}\n\n.agcx-ft-transfer-input-wrap .input-suffix {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.agcx-ft-transfer-input-wrap .input-suffix span {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.agcx-ft-transfer-input-wrap .input-suffix .divider {\n  width: 1px;\n  height: 20px;\n  background: rgba(15, 23, 42, 0.1);\n}\n\n.agcx-ft-transfer-input-wrap .all-btn {\n  background: transparent;\n  border: 0;\n  color: #D1AA67;\n  padding: 0px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.agcx-ft-transfer-avail {\n  margin-top: 0px;\n  font-size: 12px;\n  color: #B4B8C0;\n  font-weight: 500;\n}\n\n@keyframes agcx-ft-transfer-skeleton-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.agcx-ft-transfer-balance-skeleton {\n  display: inline-block;\n  vertical-align: middle;\n  width: 100px;\n  height: 12px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #2a2e36 0%, #3a3f4a 45%, #2a2e36 90%);\n  background-size: 200% 100%;\n  animation: agcx-ft-transfer-skeleton-shimmer 1.35s ease-in-out infinite;\n}\n\nbody.light_theme .agcx-ft-transfer-balance-skeleton {\n  background: linear-gradient(90deg, #e8eaed 0%, #f1f5f9 45%, #e8eaed 90%);\n  background-size: 200% 100%;\n  animation: agcx-ft-transfer-skeleton-shimmer 1.35s ease-in-out infinite;\n}\n\n.agcx-ft-btn--primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agcx-ft-transfer-actions {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.agcx-ft-btn--ghost {\n  background: #DDDDDD;\n  color: #303236;\n  border: none;\n  border-radius: 50px;\n  font-weight: 500;\n}\n\n/* \n.agcx-ft-btn--ghost:hover {\n  background: #e2e8f0;\n} */\n\n.agcx-ft-transfer-field--to,\n.agcx-ft-transfer-field--from {\n  position: relative;\n}\n\n.agcx-ft-transfer-box.is-select.is-active {\n  border-color: #0f172a;\n}\n\n.agcx-ft-transfer-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  border-radius: 12px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  overflow: hidden;\n  padding: 8px 0;\n}\n\n.agcx-ft-transfer-dropdown-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.agcx-ft-transfer-dropdown-item:hover {\n  background: #f8fafc;\n}\n\n.agcx-ft-transfer-dropdown-item.is-selected {\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.agcx-ft-transfer-dropdown-item .item-label {\n  font-size: 14px;\n}\n\n.agcx-ft-transfer-dropdown-item .item-action {\n  font-size: 12px;\n  color: #2563eb;\n  font-weight: 500;\n}\n\n.agcx-ft-transfer-dropdown--coins {\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.agcx-ft-transfer-dropdown--coins .coin-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.agcx-ft-transfer-dropdown--coins .coin-info img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.agcx-ft-transfer-dropdown--coins .text-primary {\n  color: #2563eb !important;\n}\n\n/* Quick-select coin chips (below Coin field) */\n.agcx-ft-transfer-quick-coins {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 10px;\n}\n\n.agcx-ft-quick-coin {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.agcx-ft-quick-coin-radio {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid #cbd5e1;\n  background: #fff;\n  flex-shrink: 0;\n  position: relative;\n  transition: border-color 0.15s;\n}\n\n.agcx-ft-quick-coin-radio.is-checked {\n  border-color: #272727;\n}\n\n.agcx-ft-quick-coin-radio.is-checked::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #272727;\n}\n\n.dark-mode .agcx-ft-quick-coin {\n  color: #f1f5f9;\n}\n\n.dark-mode .agcx-ft-quick-coin-radio {\n  border-color: #475569;\n  background: #1e293b;\n}\n\n.agcx-ft-modal-panel--coin-select {\n  max-width: 540px;\n  min-height: 580px;\n  display: flex;\n  flex-direction: column;\n}\n\n.agcx-ft-coin-search {\n  position: relative;\n  margin: 16px 20px;\n}\n\n.agcx-ft-coin-search input {\n  width: 100%;\n  padding: 12px 16px 12px 40px;\n  background: #f8fafc;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 10px;\n  font-size: 14px;\n  color: #0f172a;\n  outline: none;\n  transition: all 0.2s;\n}\n\n/* .agcx-ft-coin-search input:focus {\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n} */\n\n.agcx-ft-coin-search i {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #64748b;\n  font-size: 18px;\n}\n\n.agcx-ft-coin-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 12px 16px;\n  max-height: 440px;\n}\n\n.agcx-ft-coin-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-bottom: 4px;\n}\n\n.agcx-ft-coin-item:hover {\n  background: #f8fafc;\n}\n\n.coin-item-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.coin-item-left img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  object-fit: contain;\n}\n\n.coin-item-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.coin-short {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.coin-full {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.agcx-ft-coin-item .ri-check-line {\n  color: #000000 !important;\n  font-size: 20px;\n}\n\n.agcx-ft-amt-unit-btn {\n  display: flex !important;\n  align-items: center;\n  gap: 4px;\n  background: transparent;\n  border: 0;\n  padding: 0 0px !important;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  height: 100%;\n}\n\nbody .trade-wrapper.spot span.input-group-text.text-start.trade_amount_coin_badge {\n  padding: 0px !important;\n}\n\n.agcx-ft-amt-unit-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: transparent;\n  border: 0;\n  padding: 0 8px;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  height: 100%;\n  transition: all 0.2s;\n}\n\n.agcx-ft-amt-unit-btn:hover {\n  color: #0f172a;\n}\n\n.agcx-ft-amt-unit-btn span {\n  color: inherit;\n}\n\n.agcx-ft-amt-unit-btn i {\n  font-size: 14px;\n  color: #94a3b8;\n}\n\n/* Sub-fields Collapsible Sections */\n.agcx-ft-checkbox-fields-wrap {\n  margin: 5px 0px 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.stop_checks.limit_buy_checks {\n  /* justify-content: space-between; */\n  width: 100%;\n  flex-direction: row;\n  font-size: 12px;\n  gap: 25px;\n}\n\n/* .stop_check {\n  width: 100%;\n} */\n\n.stop_checks.limit_buy_checks.d-flex.align-items-center.mb-0 {\n  justify-content: space-between;\n  flex-direction: row;\n  width: 100%;\n}\n\n.stop_checks.limit_buy_checks.d-flex.align-items-center.mt-2.mb-2 {\n  flex-direction: row;\n}\n\n.stop_checks.limit_buy_checks span {\n  color: #484848;\n}\n\n@keyframes agcxFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n.agcx-ft-desktop-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.agcx-ft-desktop-actions .btn {\n  flex: 1 1;\n  height: 40px;\n  border-radius: 50px;\n  font-weight: 500;\n  font-size: 14px;\n  border: none;\n}\n\n.agcx-ft-desktop-actions .btn-buy {\n  background: #00c087;\n  color: #ffffff;\n}\n\n.agcx-ft-desktop-actions .btn-sell {\n  background: #f84960;\n  color: #ffffff;\n}\n\n.agcx-ft-trade-info {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 16px;\n  padding: 0 4px;\n}\n\n.agcx-ft-trade-info-column {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.agcx-ft-trade-info-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #848e9c;\n}\n\n.agcx-ft-trade-info-label {\n  color: #848e9c;\n}\n\n.agcx-ft-trade-info-value {\n  color: #f0b90b;\n  font-weight: 500;\n}\n\n/* Dark mode overrides if needed, but #848e9c is standard */\n.agcx-ft-trade-info-value {\n  color: #ffffff;\n}\n\nbody.light_theme .agcx-ft-trade-info-value {\n  color: #000000;\n}\n\n.agcx-ft-desktop-actions .btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n\n.agcx-ft-subfield-section.no-header {\n  padding-top: 12px;\n  width: 100%;\n}\n\n.dark-mode .agcx-ft-subfield-section {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n\n.agcx-ft-subfield-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.agcx-ft-subfield-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.agcx-ft-subfield-link {\n  font-size: 12px;\n  color: #efefef;\n  text-decoration: none;\n}\n\nbody.light_theme .agcx-ft-subfield-link {\n  color: #000000;\n}\n\n.agcx-ft-subfield-link:hover {\n  text-decoration: underline;\n  color: #efefef;\n}\n\nbody.light_theme .agcx-ft-subfield-link:hover {\n  color: #000000;\n}\n\n.agcx-ft-subfield-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.agcx-ft-subfield-row:last-child {\n  margin-bottom: 0;\n}\n\n.agcx-ft-subfield-label {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.agcx-ft-subfield-input-group {\n  display: flex;\n  align-items: center;\n  background: #2B313C;\n  /* border: 1px solid #f5f6f714; */\n  border-radius: 6px;\n  height: 43px;\n  overflow: hidden;\n  transition: border-color 0.2s;\n}\n\nbody.light_theme .agcx-ft-subfield-input-group {\n  background: #F5F6F7;\n  border: 1px solid #F5F6F7;\n}\n\n.dark-mode .agcx-ft-subfield-input-group {\n  background: #0f172a;\n  border-color: #334155;\n}\n\n.agcx-ft-subfield-input-group:focus-within {\n  border-color: #3b82f6;\n}\n\n.agcx-ft-subfield-input {\n  flex: 1;\n  background: transparent;\n  border: 0;\n  padding: 0 12px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  width: 100%;\n  font-weight: 500;\n}\n\nbody.light_theme .agcx-ft-subfield-input {\n  color: #1e293b;\n}\n\n.dark-mode .agcx-ft-subfield-input {\n  color: #f8fafc;\n}\n\n.agcx-ft-subfield-unit-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: 0;\n  padding: 0 10px;\n  height: 100%;\n  color: #f7f7f7;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\nbody.light_theme .agcx-ft-subfield-unit-btn {\n  color: #000000;\n}\n\n.dark-mode .agcx-ft-subfield-unit-btn {\n  background: #1e293b;\n  border-left-color: #334155;\n  color: #94a3b8;\n}\n\n.agcx-ft-subfield-unit-btn i {\n  font-size: 14px;\n  color: #94a3b8;\n}\n\n/* Specific button styles to override existing ones if needed */\n.agcx-ft-amt-unit-btn span {\n  font-weight: 600;\n  color: #fff;\n}\n\nbody.light_theme .agcx-ft-amt-unit-btn span {\n  color: #0f172a;\n}\n\n.dark-mode .agcx-ft-amt-unit-btn span {\n  color: #f8fafc;\n}\n\n.trade_amount_coin_badge {\n  background: transparent !important;\n  border-left: 0 !important;\n  padding-left: 0 !important;\n}\n\n.trade_amount_field_wrap,\n.trade_amount_field_limit {\n  position: relative;\n  overflow: visible;\n}\n\n.agcx-ft-amt-hint {\n  position: absolute;\n  left: 10px;\n  bottom: calc(100% - 8px);\n  z-index: 30;\n  max-width: calc(100% - 12px);\n  padding: 6px 8px;\n  border-radius: 4px;\n  background: #2b313d;\n  color: #fff;\n  font-size: 12px;\n  line-height: 16px;\n  white-space: nowrap;\n  pointer-events: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n\n.agcx-ft-amt-hint::after {\n  content: \"\";\n  position: absolute;\n  left: 18px;\n  bottom: -5px;\n  border-width: 5px 5px 0;\n  border-style: solid;\n  border-color: #3d3d3d transparent transparent;\n}\n\n/* TIF Modal Styles */\n.agcx-ft-modal-panel--tif {\n  max-width: 660px;\n}\n\n.agcx-ft-tif-card {\n  background: #00000052;\n  border: none;\n  border-radius: 12px;\n  padding: 20px;\n  width: 100%;\n  transition: all 0.2s;\n  box-shadow: 0px 0px 18px #c5c5c50f;\n}\n\nbody.light_theme .agcx-ft-tif-card {\n  background: #ffffff;\n  box-shadow: 0px 0px 18px #c5c5c573;\n}\n\n/* .agcx-ft-tif-card:hover {\n  border-color: #cbd5e1 !important;\n  background: #f8fafc !important;\n} */\n\n.agcx-ft-tif-card.is-selected {\n  border-color: #0f172a !important;\n  background: #00000052 !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\nbody.light_theme .agcx-ft-tif-card.is-selected {\n  background: #ffffff !important;\n}\n\n.agcx-ft-tif-card__title {\n  font-weight: 500;\n  font-size: 18px;\n  color: #dfdfdf;\n  margin-bottom: 10px;\n}\n\nbody.light_theme .agcx-ft-tif-card__title {\n  color: #282e3b;\n}\n\n.agcx-ft-tif-card__desc {\n  font-size: 16px;\n  color: #748093;\n  line-height: 1.4;\n}\n\n.agcx-ft-tif-check-box {\n  border: 1.5px solid #e2e8f0;\n  border-radius: 4px;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.agcx-ft-modal-body .agcx-ft-contract-list {\n  padding: 0px;\n}\n\n.agcx-ft-modal-body .agcx-ft-coin-list {\n  padding: 0px;\n}\n\n.agcx-ft-modal-body .agcx-ft-coin-search {\n  margin: 0px;\n  margin-bottom: 10px;\n}\n\n.agcx-ft-tif-check-box.is-checked {\n  background: #0f172a;\n  border-color: #0f172a;\n}\n\n.agcx-ft-tif-check-box.is-checked i {\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.dark-mode .agcx-ft-tif-card {\n  background: #1e293b !important;\n  border-color: #334155 !important;\n}\n\n.dark-mode .agcx-ft-tif-card.is-selected {\n  border-color: #f8fafc !important;\n  background: #1e293b !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.dark-mode .agcx-ft-tif-card__title {\n  color: #f8fafc !important;\n}\n\n.dark-mode .agcx-ft-tif-card__desc {\n  color: #94a3b8 !important;\n}\n\n.dark-mode .agcx-ft-tif-check-box {\n  border-color: #475569;\n}\n\n.dark-mode .agcx-ft-tif-check-box.is-checked {\n  background: #f8fafc !important;\n  border-color: #f8fafc !important;\n}\n\n.dark-mode .agcx-ft-tif-check-box.is-checked i {\n  color: #0f172a !important;\n}\n\n/* TIF row — label + button (moved from inline styles) */\n.agcx-ft-tif-label {\n  color: #94a3b8;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.agcx-ft-tif-btn {\n  background: none;\n  border: 0;\n  padding: 0;\n  color: #e1e1e1;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\nbody.light_theme .agcx-ft-tif-btn {\n  color: #0f172a;\n}\n\n.agcx-ft-tif-btn i {\n  font-size: 18px;\n}\n\n.dark-mode .agcx-ft-tif-label {\n  color: #94a3b8;\n}\n\n.dark-mode .agcx-ft-tif-btn {\n  color: #f8fafc !important;\n}\n\n\n\n\n@media (max-width: 1024px) {\n\n  .static-action-btn {\n    padding: 4px 18px;\n  }\n\n  .agcx-ft-modal-root {\n    z-index: 9999999999 !important;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n\n  .agcx-ft-trade-info {\n    margin: 10px 0px;\n    padding: 0 0px;\n  }\n\n  .headline_left__lBBPY .scroll-subtabs_tabs__Prom8 {\n    padding-right: 0px;\n  }\n\n  .agcx-ft-trade-info-value {\n    font-weight: 400;\n  }\n\n  .agcx-ft-modal-panel--calc {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .agcx-ft-modal-root {\n    align-items: end;\n    z-index: 99999999;\n  }\n\n  .agcx-ft-modal-panel {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 14px 14px 0px 0px;\n  }\n\n  .agcx-margin-lvg-modal-panel {\n    height: 85vh;\n    overflow: scroll;\n  }\n\n  .agcx-ft-tif-card__title {\n    font-size: 16px;\n  }\n\n  .agcx-ft-tif-card__desc {\n    font-size: 14px;\n  }\n\n  .agcx-ft-modal-body {\n    padding: 20px 20px 22px;\n  }\n\n  .agcx-ft-modal-head {\n    padding: 18px 20px 18px;\n    margin-top: 0px;\n  }\n\n  .agcx-ft-modal-title {\n    font-size: 20px;\n  }\n\n\n\n  .agcx-ft-transfer-field label {\n    font-size: 14px;\n  }\n\n  .agcx-ft-transfer-swap {\n    padding: 0px;\n  }\n\n  .agcx-ft-modal-body .agcx-ft-coin-list {\n    padding: 0px;\n    max-width: 100%;\n  }\n\n  .agcx-ft-modal-body .agcx-ft-coin-search {\n    margin: 0px;\n  }\n\n  .agcx-ft-batch-confirm {\n    min-height: 42px;\n    font-size: 12px;\n  }\n\n  .agcx-ft-btn--primary {\n    height: 36px;\n    font-size: 12px;\n  }\n\n  .agcx-ft-transfer-box {\n    border-radius: 8px;\n    padding: 10px 11px;\n    font-size: 13px;\n    min-height: 44px;\n  }\n\n  .agcx-ft-calc-results-card {\n    min-height: 100%;\n  }\n\n}\n\n/* Desktop assets rail — Contract Details card (futures_trade) */\n.assets_panel_list_card .assets_contract_details {\n  padding: 4px 0 8px;\n}\n\n.assets_contract_details_title {\n  margin: 20px 0 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  font-family: \"Inter\", sans-serif;\n  border-bottom: 1px solid #EDEFF2;\n  padding-bottom: 10px;\n}\n\n.assets_contract_details_row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 7px 0;\n  font-size: 12px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.assets_contract_details_label {\n  color: #686868;\n  font-weight: 400;\n  flex-shrink: 0;\n}\n\n.assets_contract_details_val {\n  color: #191919;\n  text-align: right;\n  min-width: 0;\n}\n\n.static-action-btn {\n  font-size: 11px;\n  background: #303236;\n  color: #fff !important;\n  border: none !important;\n  transition: all 0.2s ease;\n}\n\n.static-action-btn:hover {\n  background: #3c3e42;\n  color: #fff !important;\n}\n\n.static-table-wrap {\n  min-height: 350px;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n/* Hiding mobile view on desktop */\n.order_history_mobile_view,\n.so-mobile,\n.twomobile {\n  display: none !important;\n}\n\n\n\n/* Centering No-Data State across different sections */\n.spot_orders_placeholder_shell,\n.spot_orders_no_data_row td,\n.no-data-wrapper,\n.orderbook-empty-state,\n.no_data_s {\n  align-items: center !important;\n  justify-content: center !important;\n  min-height: 200px !important;\n  width: 100% !important;\n  flex-direction: column !important;\n  text-align: center !important;\n}\n\n.spot_orders_empty_state {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 40px 0 !important;\n  width: 100% !important;\n}\n\n.spot_orders_empty_telescope {\n  margin: 0 auto !important;\n}\n\n.adl-dot {\n  width: 6px;\n  height: 6px;\n  background-color: #0ecb81;\n  border-radius: 50%;\n}\n\n/* ADL — 5 equal dots (not signal bars) */\n.agce-ft-adl {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  min-width: 42px;\n}\n\n.agce-ft-adl-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: #d5dae2;\n  flex-shrink: 0;\n}\n\n.agce-ft-adl-dot--on.agce-ft-adl-dot--low {\n  background-color: #0ecb81;\n}\n\n.agce-ft-adl-dot--on.agce-ft-adl-dot--mid {\n  background-color: #f0b90b;\n}\n\n.agce-ft-adl-dot--on.agce-ft-adl-dot--high {\n  background-color: #f6465d;\n}\n\n.agce-ft-wallet-hist-pager {\n  border-top: 1px solid #eaecef;\n}\n\n/* Right-bottom Account panel (Binance-style) */\n.assets_right.agce-ft-acct-rail {\n  border-radius: 8px;\n  padding: 0;\n  min-width: 19%;\n  max-width: 19%;\n  flex-shrink: 0;\n}\n\n.agce-ft-acct-panel {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 14px 14px 12px;\n  font-family: \"Inter\", sans-serif;\n  color: #1e2329;\n}\n\n.agce-ft-acct-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #eaecef;\n  margin-bottom: 12px;\n}\n\n.agce-ft-acct-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n}\n\nbody.light_theme .agce-ft-acct-title {\n  color: #1e2329;\n}\n\n.agce-ft-acct-switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #f0b90b;\n  text-decoration: none !important;\n}\n\n.agce-ft-acct-switch:hover {\n  color: #d9a409;\n}\n\n.agce-ft-acct-section {\n  margin-bottom: 10px;\n}\n\n.agce-ft-acct-section-title {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n}\n\nbody.light_theme .agce-ft-acct-section-title {\n  color: #1e2329;\n}\n\n.agce-ft-acct-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 4px 0;\n  font-size: 12px;\n}\n\n.agce-ft-acct-row--main {\n  font-weight: 500;\n  color: #fff;\n  padding-bottom: 6px;\n}\n\nbody.light_theme .agce-ft-acct-row--main {\n  color: #1e2329;\n}\n\n.agce-ft-acct-row-end {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.agce-ft-acct-label {\n  color: #848e9c;\n}\n\nbody.light_theme .agce-ft-acct-val {\n  color: #1e2329;\n}\n\n.agce-ft-acct-val {\n  color: #dedede;\n  font-weight: 500;\n  text-align: right;\n}\n\n.agce-ft-acct-val--profit {\n  color: #0ecb81 !important;\n}\n\n.agce-ft-acct-val--loss {\n  color: #f6465d !important;\n}\n\n.agce-ft-acct-mode-btn {\n  width: 100%;\n  border: none;\n  border-radius: 6px;\n  background: #f0f1f2;\n  color: #1e2329;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 8px 12px;\n  margin-bottom: 12px;\n  cursor: default;\n}\n\n.agce-ft-acct-section--asset {\n  border-top: 1px solid #eaecef;\n  padding-top: 10px;\n  margin-bottom: 10px;\n}\n\n.agce-ft-acct-asset-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 0 0 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n}\n\nbody.light_theme .agce-ft-acct-asset-toggle {\n  color: #1e2329;\n}\n\n.agce-ft-acct-pnl-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  border: 1px solid #eaecef;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #1e2329;\n  text-decoration: none !important;\n  transition: background 0.15s ease;\n}\n\n.agce-ft-acct-pnl-link:hover {\n  background: #fafafa;\n  color: #1e2329;\n}\n\n.agce-ft-acct-pnl-link i {\n  font-size: 16px;\n  color: #848e9c;\n}\n\n.agce-ft-acct-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.agce-ft-acct-action-btn {\n  flex: 1 1 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 32px;\n  border: none;\n  border-radius: 6px;\n  background: #f0f1f2;\n  color: #1e2329 !important;\n  font-size: 11px;\n  font-weight: 500;\n  text-decoration: none !important;\n  padding: 6px 4px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.agce-ft-acct-action-btn:hover {\n  background: #e8eaed;\n  color: #1e2329 !important;\n}\n\n.agce-ft-acct-login {\n  padding: 24px 12px;\n  text-align: center;\n  font-size: 12px;\n  color: #848e9c;\n}\n\n.agce-ft-acct-login-btn {\n  display: inline-block;\n  margin-top: 8px;\n  padding: 6px 16px;\n  border-radius: 6px;\n  background: #d1aa67;\n  color: #1e2329 !important;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none !important;\n}\n\nhtml[data-theme=\"dark\"] .assets_right.agce-ft-acct-rail {\n  background: #181a20;\n  border-color: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .agce-ft-acct-panel {\n  color: #eaecef;\n}\n\nhtml[data-theme=\"dark\"] .agce-ft-acct-title,\nhtml[data-theme=\"dark\"] .agce-ft-acct-section-title,\nhtml[data-theme=\"dark\"] .agce-ft-acct-row--main,\nhtml[data-theme=\"dark\"] .agce-ft-acct-val,\nhtml[data-theme=\"dark\"] .agce-ft-acct-asset-toggle,\nhtml[data-theme=\"dark\"] .agce-ft-acct-pnl-link {\n  color: #eaecef;\n}\n\nhtml[data-theme=\"dark\"] .agce-ft-acct-head,\nhtml[data-theme=\"dark\"] .agce-ft-acct-section--asset {\n  border-color: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .agce-ft-acct-mode-btn,\nhtml[data-theme=\"dark\"] .agce-ft-acct-action-btn {\n  background: #2b3139;\n  color: #eaecef !important;\n}\n\nhtml[data-theme=\"dark\"] .agce-ft-acct-pnl-link {\n  border-color: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .agce-ft-acct-pnl-link:hover {\n  background: #2b3139;\n}\n\n/* Positions table — Close opens modal (no inline price/qty inputs) */\n.agce-ft-close-pos-cell {\n  vertical-align: middle !important;\n  text-align: right;\n  min-width: 88px;\n}\n\n.agce-ft-close-pos__open-btn {\n  border: none !important;\n  border-radius: 6px !important;\n  background: #30323600 !important;\n  color: #d09f52 !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  line-height: 1 !important;\n  padding: 8px 14px !important;\n  cursor: pointer !important;\n  transition: background 0.15s ease, opacity 0.15s ease !important;\n  text-decoration: underline !important;\n}\n\n.agce-ft-close-pos__open-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.agce-ft-close-pos__open-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\nbody.light_theme .agce-ft-close-pos__open-btn {\n  background: #f0f1f2;\n  color: #b45309;\n}\n\nbody.light_theme .agce-ft-close-pos__open-btn:hover:not(:disabled) {\n  background: #e5e7eb;\n}\n\n.so-mobileCard__row .agce-ft-close-pos__open-btn {\n  width: 100%;\n  max-width: 140px;\n}\n\n.agce-ft-pos-margin {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.agce-ft-pos-margin__text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.25;\n}\n\n.agce-ft-pos-margin__value {\n  font-weight: 600;\n}\n\n.agce-ft-pos-margin__mode {\n  font-size: 11px;\n  color: #848e9c;\n}\n\n.agce-ft-pos-margin__edit {\n  border: none;\n  background: transparent !important;\n  color: #848e9c !important;\n  padding: 0 !important;\n  cursor: pointer;\n  font-size: 15px !important;\n  font-weight: 800 !important;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n\n.agce-ft-pos-margin__edit:hover {\n  color: #d1aa67;\n}\n\nbody.light_theme .agce-ft-pos-margin__mode,\nbody.light_theme .agce-ft-pos-margin__edit {\n  color: #9a9da3;\n}\n\nbody.light_theme .agce-ft-pos-margin__edit:hover {\n  color: #d1aa67;\n}\n\n.agce-ft-adj-margin-hint {\n  margin: 4px 0 14px;\n  font-size: 12px;\n  color: #848e9c;\n}\n\nbody.light_theme .agce-ft-adj-margin-hint {\n  color: #9a9da3;\n}\n\n/* Futures close position modal */\n.agce-ft-close-modal-dialog {\n  max-width: 380px !important;\n  width: calc(100% - 32px);\n  margin: 1rem auto;\n}\n\n.agce-ft-close-modal-content {\n  overflow: hidden;\n}\n\n.agce-ft-close-modal-side-pill {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 4px;\n  line-height: 1.3;\n}\n\n.agce-ft-close-modal-side-pill--long {\n  background: rgba(1, 188, 141, 0.15);\n  color: #01bc8d;\n}\n\n.agce-ft-close-modal-side-pill--short {\n  background: rgba(228, 85, 97, 0.15);\n  color: #e45561;\n}\n\n.agce-ft-close-modal-tabs {\n  display: flex;\n  gap: 0;\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 10px;\n  padding: 3px;\n  margin-bottom: 16px;\n}\n\nbody.light_theme .agce-ft-close-modal-tabs {\n  background: #f3f4f6;\n}\n\n.agce-ft-close-modal-tab {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: #9ca3af;\n  border-radius: 8px;\n  padding: 8px 0;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.agce-ft-close-modal-tab.is-active {\n  background: rgb(43 49 61);\n  color: #fff;\n}\n\nbody.light_theme .agce-ft-close-modal-tab.is-active {\n  background: #fff;\n  color: #111827;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.agce-ft-close-modal-field-label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.agce-ft-close-modal-field-label-row label {\n  margin: 0;\n}\n\n.agce-ft-close-modal-mark-hint {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.agce-ft-close-modal-pcts {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.agce-ft-close-modal-pct {\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  background: #2B313C;\n  color: #d1d5db;\n  border-radius: 8px;\n  padding: 9px 0;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.agce-ft-close-modal-pct.is-active {\n  background: rgb(209 170 103 / 10%);\n  border-color: rgb(209 170 103 / 70%);\n  color: rgb(209 170 103);\n  font-weight: 600;\n}\n\nbody.light_theme .agce-ft-close-modal-pct {\n  background: #F5F5F5;\n  border-color: #e5e7eb;\n  color: #374151;\n}\n\nbody.light_theme .agce-ft-close-modal-pct.is-active {\n  background: rgb(209 170 103 / 10%);\n  border-color: #d1aa67;\n  color: #d1aa67;\n}\n\n.agce-ft-close-modal-summary {\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 10px;\n  padding: 14px;\n  margin-bottom: 12px;\n}\n\nbody.light_theme .agce-ft-close-modal-summary {\n  background: #f9fafb;\n}\n\n.agce-ft-close-modal-summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.agce-ft-close-modal-summary-row+.agce-ft-close-modal-summary-row {\n  margin-top: 8px;\n}\n\n.agce-ft-close-modal-summary-row>span:first-child {\n  color: #9ca3af;\n}\n\n.agce-ft-close-modal-summary-row>span:last-child {\n  color: #fff;\n  font-weight: 500;\n  text-align: right;\n}\n\nbody.light_theme .agce-ft-close-modal-summary-row>span:last-child {\n  color: #111827;\n}\n\n/* Match Borrow/Repay amount field: style.css only targets input[type=number] */\nbody:not(.light_theme) .margin-modal-container .modern-margin-form .price_max_total {\n  background-color: #2B313C !important;\n  border: 1px solid transparent !important;\n  border-radius: 8px !important;\n  padding: 4px 12px !important;\n}\n\nbody.light_theme .margin-modal-container .modern-margin-form .price_max_total {\n  background-color: #F5F5F5 !important;\n  border: 1px solid #EAECEF !important;\n  border-radius: 8px !important;\n  padding: 4px 12px !important;\n  color: #1E2329;\n}\n\n.margin-modal-container .modern-margin-form .price_max_total.is-error {\n  border-color: #f6465d !important;\n}\n\n.margin-modal-container .modern-margin-form .price_max_total input[type=\"text\"] {\n  padding: 10px 18px;\n  font-size: 13px;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  width: 90%;\n  color: #fff;\n  font-weight: 500;\n}\n\nbody.light_theme .margin-modal-container .modern-margin-form .price_max_total input[type=\"text\"] {\n  color: #1E2329;\n}\n\n.margin-modal-container .modern-margin-form .price_max_total input[type=\"text\"]::placeholder {\n  color: #9ca3af;\n  opacity: 1;\n}\n\n.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--long,\n.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--short {\n  background-color: #d1aa67;\n  color: #040404;\n}\n\n.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--long:hover:not(:disabled),\n.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--short:hover:not(:disabled),\n.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--long:focus:not(:disabled),\n.agce-ft-close-modal-confirm.agce-ft-close-modal-confirm--short:focus:not(:disabled) {\n  background-color: #d1aa67;\n  color: #040404;\n}\n\n@media (max-width: 480px) {\n  .agce-ft-close-modal-dialog {\n    max-width: 100% !important;\n    width: calc(100% - 24px);\n    margin: 0.75rem auto;\n  }\n\n  .agce-ft-close-modal-pct {\n    padding: 10px 0;\n    font-size: 12px;\n  }\n}\n\n.trade_summary_table_lft .spot_orders_table thead th.yellowcolor {\n  color: #f3bb2b;\n}\n\n/* Futures position PnL — applied on inner elements to beat table td color rules */\n.agce-ft-pnl--profit {\n  color: #0ecb81 !important;\n}\n\n.agce-ft-pnl--loss {\n  color: #f6465d !important;\n}\n\n.trade_summary_table_lft .spot_orders_table tbody td .agce-ft-pnl--profit,\n.trade_summary_table_lft .spot_orders_table tbody td.agce-ft-pnl--profit,\n.trade_summary_table_lft .so-mobileCard__row .agce-ft-pnl--profit,\n.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--profit {\n  color: #0ecb81 !important;\n}\n\n.trade_summary_table_lft .spot_orders_table tbody td .agce-ft-pnl--loss,\n.trade_summary_table_lft .spot_orders_table tbody td.agce-ft-pnl--loss,\n.trade_summary_table_lft .so-mobileCard__row .agce-ft-pnl--loss,\n.trade_summary_table_lft .so-mobileCard__row>span.agce-ft-pnl--loss {\n  color: #f6465d !important;\n}\n\n@media (max-width: 1200px) {\n\n  .order_history_mobile_view,\n  .so-mobile,\n  .twomobile {\n    display: block !important;\n  }\n\n}\n\n\n@media (max-width: 580px) {\n  .agcx-ft-modal-panel--avg .agcx-ft-calc-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.trade_fee_row_new {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 5px 0px;\n  padding: 0 4px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.fee_hover_container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.fee_trigger_wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.fee_badge_v0 {\n  background: #f0f1f2;\n  color: #5e6673;\n  font-size: 11px;\n  font-weight: 700;\n  font-style: italic;\n  padding: 1px 6px;\n  border-radius: 10px;\n  line-height: 1.2;\n}\n\n.fee_info_icon {\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.fee_separator {\n  color: #e2e8f0;\n  margin: 0 4px;\n  font-weight: 300;\n}\n\n.fee_text {\n  font-size: 12px;\n  color: #fff;\n  font-weight: 400;\n  white-space: nowrap;\n}\n\nbody.light_theme .fee_text {\n  color: #1e2329;\n}\n\n.fee_detail_popup {\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  margin-bottom: 10px;\n  width: 280px;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 16px;\n  display: none;\n  z-index: 100;\n}\n\n.fee_detail_popup::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 20px;\n  background: transparent;\n}\n\n.fee_hover_container:hover .fee_detail_popup {\n  display: block;\n}\n\n.fee_popup_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.fee_popup_title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1e2329;\n  border-bottom: 1px dotted #bcbcbc;\n  padding-bottom: 2px;\n}\n\n.fee_popup_header_right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.fee_badge_v0--small {\n  font-size: 10px;\n}\n\n.fee_level_up_link {\n  font-size: 13px;\n  color: #0f0f0f;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.fee_popup_rate_row {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 12px 0;\n  margin-bottom: 8px;\n}\n\n.fee_popup_rate_item {\n  display: flex;\n  align-items: center;\n}\n\n.fee_popup_rate_label {\n  font-size: 11px;\n  color: #707a8a;\n}\n\n.fee_popup_rate_val {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1e2329;\n}\n\n.fee_popup_divider {\n  color: #e2e8f0;\n  margin: 0 4px;\n}\n\n.fee_pay_points_btn {\n  background: #f0f1f2;\n  color: #1e2329;\n  border: none;\n  padding: 4px 9px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 16px;\n  width: auto;\n  display: inline-block;\n}\n\n.fee_popup_footer {\n  font-size: 12px;\n  color: #848e9c;\n  line-height: 1.5;\n  border-top: 1px solid #f0f1f2;\n  padding-top: 12px;\n}\n\n.dark-mode .fee_badge_v0 {\n  background: #2b3139;\n  color: #848e9c;\n}\n\n.dark-mode .fee_text {\n  color: #eaecef;\n}\n\n.dark-mode .fee_separator {\n  color: #334155;\n}\n\n.dark-mode .fee_detail_popup {\n  background: #1e2329;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\n}\n\n.dark-mode .fee_popup_title,\n.dark-mode .fee_popup_rate_val {\n  color: #eaecef;\n}\n\n.dark-mode .fee_popup_rate_row {\n  background: transparent;\n}\n\n.dark-mode .fee_pay_points_btn {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.dark-mode .fee_popup_footer,\n.dark-mode .fee_popup_header {\n  border-color: #2b3139;\n}\n\n@media screen and (max-width: 1200px) {\n\n  .assets_right.agce-ft-acct-rail {\n    min-width: 100%;\n    max-width: 100%;\n  }\n\n}\n\n@media screen and (max-width: 991px) {\n\n  .order_history_mobile_view,\n  .so-mobile,\n  .twomobile {\n    display: block !important;\n  }\n\n  button.agce-margin-filter-toggle-btn.agce-futures-filter-toggle-btn {\n    margin-left: 12px;\n  }\n\n  .agce-futures-points-card {\n    margin-bottom: 20px;\n  }\n\n  .trade_fee_row_new {\n    margin-top: 0px;\n  }\n}\n\n/* ==========================================================================\n   Dark Theme (Default) Overrides for Calculator & Contract Unit Modals\n   ========================================================================== */\n\nbody:not(.light_theme) .agcx-ft-modal-backdrop {\n  background: rgb(0 0 0 / 60%);\n}\n\nbody:not(.light_theme) .agcx-ft-modal-panel {\n  background: #1a1a1a69;\n  border: 1px solid rgb(255 255 255 / 3%);\n  color: #ffffff;\n  box-shadow: 0 18px 48px rgb(0 0 0 / 70%);\n}\n\nbody:not(.light_theme) .agcx-ft-modal-head {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .agcx-ft-modal-title {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-modal-close {\n  color: #9aa0a6;\n}\n\nbody:not(.light_theme) .agcx-ft-modal-close:hover {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-tabs-wrapper {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .agcx-ft-calc-tab-arrow {\n  background: #111214;\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-tab-arrow.left {\n  background: linear-gradient(to right, #111214 70%, rgba(17, 18, 20, 0));\n}\n\nbody:not(.light_theme) .agcx-ft-calc-tab-arrow.right {\n  background: linear-gradient(to left, #111214 70%, rgba(17, 18, 20, 0));\n}\n\nbody:not(.light_theme) .agcx-ft-calc-tab-arrow:hover {\n  color: #2563eb;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-tab {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-tab:before {\n  background: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-tab.is-active {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-longshort button {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-longshort button.is-on:first-child {\n  background: #00c087;\n  border-color: #00c087;\n  color: #fff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-longshort button:last-child.is-on {\n  background: #ff3b30;\n  border-color: #ff3b30;\n  color: #fff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-field {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-select,\nbody:not(.light_theme) .agcx-ft-calc-col.agcx-ft-calc-col--form .agcx-ft-calc-select {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-input {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\nbody:not(.light_theme) .agcx-ft-calc-input:focus-within {\n  border-color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-input input {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-input span {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-results-card {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .agcx-ft-calc-out-row span:first-child {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-out-row span:last-child {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-liq-note {\n  color: #64748b;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-avg-head {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-avg-row:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\nbody:not(.light_theme) .avg-no {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-avg-delete:hover {\n  background: rgba(239, 68, 68, 0.2);\n}\n\nbody:not(.light_theme) .agcx-ft-calc-add-btn {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-add-btn:hover {\n  background: #2b313c;\n  color: #ffffff;\n  border-color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-note {\n  background: #1e2329;\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-calc-note a {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-btn--primary {\n  background: #2b313c;\n  color: #8e9299;\n}\n\nbody:not(.light_theme) .agcx-ft-btn--primary.is-active,\nbody:not(.light_theme) .agcx-ft-btn--primary:not(:disabled) {\n  background: #d1aa67;\n  color: #0f172a;\n}\n\nbody:not(.light_theme) .agcx-ft-btn--primary:disabled {\n  background: #2b313c;\n  color: #8e9299;\n  opacity: 0.6;\n}\n\nbody:not(.light_theme) .agcx-ft-contract-card {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\nbody:not(.light_theme) .agcx-ft-contract-card.is-selected {\n  border-color: #ffffff;\n  background: #2b313c;\n}\n\nbody:not(.light_theme) .agcx-ft-contract-card__title {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-contract-card__desc {\n  color: #94a3b8;\n}\n\n/* ==========================================================================\n   Dark Theme (Default) Overrides for Funds Transfer Modal\n   ========================================================================== */\n\nbody:not(.light_theme) .agcx-ft-transfer-banner {\n  background: #1e23298c;\n  color: #ffffff;\n  border: 1px solid #e4e4e407;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-field label {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-box {\n  background: #1e23298c;\n  color: #ffffff;\n  border: 1px solid #e4e4e407;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-box.is-select.is-active {\n  border-color: #ffffff14;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-dropdown {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5);\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-dropdown-item {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-dropdown-item.is-selected {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-dropdown-item .item-action {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-quick-coin {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-quick-coin-radio {\n  border-color: rgba(255, 255, 255, 0.3);\n  background: #1e2329;\n}\n\nbody:not(.light_theme) .agcx-ft-quick-coin-radio.is-checked {\n  border-color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-quick-coin-radio.is-checked::after {\n  background: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-input-wrap {\n  background: #1e23298c;\n  color: #ffffff;\n  border: 1px solid #e4e4e407;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-input-wrap:focus-within {\n  border-color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-input-wrap input {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-input-wrap .input-suffix span {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-input-wrap .input-suffix .divider {\n  background: rgba(255, 255, 255, 0.12);\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-input-wrap .all-btn {\n  color: #D1AA67;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-avail {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-btn--ghost {\n  background: #2b313c;\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\nbody:not(.light_theme) .agcx-ft-coin-search input {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.03);\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-coin-search i {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-coin-item {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .agcx-ft-coin-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\nbody:not(.light_theme) .coin-short {\n  color: #ffffff;\n}\n\nbody:not(.light_theme) .coin-full {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .agcx-ft-coin-item .ri-check-line {\n  color: #ffffff !important;\n}\n\nbody:not(.light_theme) .agcx-ft-transfer-swap:hover {\n  border-color: #ffffff;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n/* ==========================================================================\n   AGCX Custom Filter Select Styles (Replaces default select dropdown popup)\n   ========================================================================== */\n\n.agce-custom-select-container {\n  position: relative;\n  width: auto;\n  min-width: 95px;\n  display: inline-block;\n  margin-right: 6px;\n  margin-bottom: 0;\n  vertical-align: middle;\n}\n\n.agce-custom-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 30px;\n  padding: 0 10px;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 4px;\n  color: #eaecef;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n  box-sizing: border-box;\n  transition: border-color 0.2s, background-color 0.2s;\n  gap: 8px;\n  white-space: nowrap;\n}\n\nbody.light_theme .agce-custom-select-trigger {\n  background: #f6f6f7;\n  border: 1px solid #cbd5e1;\n  color: #1e2329;\n}\n\n/* .agce-custom-select-trigger:focus,\n.agce-custom-select-trigger:hover {\n  border-color: #d1aa67;\n} */\n\n.agce-custom-select-trigger i {\n  font-size: 14px;\n  transition: transform 0.2s ease;\n  color: #848e9c;\n}\n\n.agce-custom-select-trigger i.open {\n  transform: rotate(180deg);\n}\n\n.agce-custom-select-options {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  min-width: 100%;\n  width: max-content;\n  max-width: 200px;\n  max-height: 220px;\n  overflow-y: auto;\n  background: #181a20;\n  border: 1px solid #2b3139;\n  border-radius: 6px;\n  z-index: 100000;\n  padding: 4px 0;\n  margin: 0;\n  list-style: none;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.4);\n  box-sizing: border-box;\n}\n\nbody.light_theme .agce-custom-select-options {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.agce-custom-select-option {\n  padding: 8px 14px;\n  font-size: 12px;\n  color: #eaecef;\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 0.15s, color 0.15s;\n  white-space: nowrap;\n}\n\nbody.light_theme .agce-custom-select-option {\n  color: #1e2329;\n}\n\n.agce-custom-select-option:hover {\n  background: #2b3139;\n  color: #d1aa67;\n}\n\nbody.light_theme .agce-custom-select-option:hover {\n  background: #f1f5f9;\n  color: #d1aa67;\n}\n\n.agce-custom-select-option.selected {\n  background: rgba(209, 170, 103, 0.15);\n  color: #d1aa67;\n  font-weight: 600;\n}\n\nbody.light_theme .agce-custom-select-option.selected {\n  background: rgba(209, 170, 103, 0.1);\n  color: #d1aa67;\n  font-weight: 600;\n}\n\n/* Scrollbar customization for custom dropdown list */\n.agce-custom-select-options::-webkit-scrollbar {\n  width: 4px;\n}\n\n.agce-custom-select-options::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.agce-custom-select-options::-webkit-scrollbar-thumb {\n  background: #474f59;\n  border-radius: 4px;\n}\n\nbody.light_theme .agce-custom-select-options::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n}\n\n/* Mobile popup filter content adjustments */\n.agce-margin-filter-popup-content .agce-custom-select-container {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 12px;\n}\n\n.agce-margin-filter-popup-content .agce-custom-select-trigger {\n  height: 38px;\n  font-size: 13px;\n  padding: 0 12px;\n  border-radius: 8px;\n}\n\n/* Unique styling for Futures Conditional Tab USDT Suffix / Field */\n.futures_conditional_usdt_suffix {\n  display: inline-flex;\n  align-items: center;\n  padding-right: 10px;\n}\n\n.futures_conditional_field_wrap {\n  position: relative;\n}\n\n/* —— Futures margin mode modal (redesign) —— */\n.agce-ft-mm-backdrop {\n  z-index: 1050;\n}\n\n.agce-ft-mm-dialog {\n  max-width: 380px !important;\n  width: calc(100% - 32px);\n  margin: 1rem auto;\n}\n\n.agce-ft-mm-content {\n  border: none !important;\n  border-radius: 18px !important;\n  overflow: hidden;\n  background: rgb(30 35 41 / 2%) !important;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);\n}\n\nbody.light_theme .agce-ft-mm-content {\n  background: rgb(255 255 255 / 20%) !important;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n}\n\n.agce-ft-mm-body {\n  padding: 24px;\n}\n\n.agce-ft-mm-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.agce-ft-mm-title {\n  margin: 0 0 4px;\n  font-size: 19px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #eaecef;\n}\n\nbody.light_theme .agce-ft-mm-title {\n  color: #14161a;\n}\n\n.agce-ft-mm-subtitle {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.4;\n  color: #848e9c;\n}\n\nbody.light_theme .agce-ft-mm-subtitle {\n  color: #9a9da3;\n}\n\n.agce-ft-mm-close {\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  border: none;\n  border-radius: 7px;\n  background: rgba(255, 255, 255, 0.06);\n  color: #848e9c;\n  font-size: 16px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n}\n\nbody.light_theme .agce-ft-mm-close {\n  background: #f2f3f5;\n  color: #7a7f8a;\n}\n\n.agce-ft-mm-close:hover {\n  color: #eaecef;\n}\n\nbody.light_theme .agce-ft-mm-close:hover {\n  color: #14161a;\n}\n\n.agce-ft-mm-segment {\n  position: relative;\n  display: flex;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 12px;\n  padding: 4px;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .agce-ft-mm-segment {\n  background: #f2f3f5;\n}\n\n.agce-ft-mm-segment__thumb {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: calc(50% - 4px);\n  height: calc(100% - 8px);\n  background: #eaecef;\n  border-radius: 9px;\n  transition: transform 0.22s ease;\n  pointer-events: none;\n}\n\nbody.light_theme .agce-ft-mm-segment__thumb {\n  background: #14161a;\n}\n\n.agce-ft-mm-segment__thumb.is-isolated {\n  transform: translateX(100%);\n}\n\n.agce-ft-mm-segment__btn {\n  flex: 1;\n  position: relative;\n  z-index: 1;\n  background: transparent !important;\n  border: none !important;\n  border-bottom: none !important;\n  border-radius: 9px;\n  padding: 11px 0 !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  color: #848e9c !important;\n  cursor: pointer;\n}\n\n.agce-ft-mm-segment__btn:before {\n  display: none !important;\n}\n\nbody.light_theme .agce-ft-mm-segment__btn {\n  color: #9a9da3 !important;\n}\n\n.agce-ft-mm-segment__btn.is-active {\n  color: #1e2329 !important;\n}\n\nbody.light_theme .agce-ft-mm-segment__btn.is-active {\n  color: #ffffff !important;\n}\n\n.agce-ft-mm-desc {\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n  min-height: 110px;\n}\n\nbody.light_theme .agce-ft-mm-desc {\n  background: #f7f8f9;\n}\n\n.agce-ft-mm-desc p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.65;\n  color: #b7bdc6;\n}\n\nbody.light_theme .agce-ft-mm-desc p {\n  color: #4d515a;\n}\n\n.agce-ft-mm-warn {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  background: rgba(246, 70, 93, 0.12);\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin-bottom: 18px;\n}\n\nbody.light_theme .agce-ft-mm-warn {\n  background: #fdf1f1;\n}\n\n.agce-ft-mm-warn__icon {\n  color: #f6465d;\n  font-size: 15px;\n  line-height: 1.4;\n  flex-shrink: 0;\n}\n\nbody.light_theme .agce-ft-mm-warn__icon {\n  color: #a32d2d;\n}\n\n.agce-ft-mm-warn p {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: #f6465d;\n}\n\nbody.light_theme .agce-ft-mm-warn p {\n  color: #a32d2d;\n}\n\n/* ── Funding (Xh) / Countdown ticker + hover/click popup ─────────────────── */\n.agcx-ft-funding-ticker {\n  position: relative;\n}\n\n.agcx-ft-funding-ticker__trigger {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n}\n\n.agcx-ft-funding-ticker__label {\n  cursor: pointer;\n  border-bottom: 1px dotted rgba(255, 255, 255, 0.35);\n  width: fit-content;\n}\n\nbody.light_theme .agcx-ft-funding-ticker__label {\n  border-bottom-color: rgba(0, 0, 0, 0.28);\n}\n\n.agcx-ft-funding-ticker__value {\n  display: flex;\n  align-items: baseline;\n  gap: 0;\n  white-space: nowrap;\n}\n\n.agcx-ft-funding-ticker__rate {\n  color: #d1aa67;\n}\n\n.agcx-ft-funding-ticker__sep,\n.agcx-ft-funding-ticker__countdown {\n  color: inherit;\n}\n\n.agcx-ft-funding-popup {\n  width: min(360px, calc(100vw - 16px));\n  padding: 14px 14px 12px;\n  border-radius: 8px;\n  background: #1e2329;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45);\n  white-space: normal;\n  pointer-events: auto;\n}\n\n.agcx-ft-funding-popup--portal {\n  position: fixed;\n  z-index: 10050;\n}\n\nbody.light_theme .agcx-ft-funding-popup {\n  background: #ffffff;\n  border-color: #eaecef;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.agcx-ft-funding-popup__intro {\n  margin: 0 0 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: 400;\n  color: #b7bdc6;\n}\n\nbody.light_theme .agcx-ft-funding-popup__intro {\n  color: #707a8a;\n}\n\n.agcx-ft-funding-popup__rows {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.agcx-ft-funding-popup__row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.agcx-ft-funding-popup__key {\n  color: #848e9c;\n  flex: 1 1 auto;\n}\n\nbody.light_theme .agcx-ft-funding-popup__key {\n  color: #707a8a;\n}\n\n.agcx-ft-funding-popup__val {\n  color: #eaecef;\n  text-align: right;\n  flex: 0 1 auto;\n  font-variant-numeric: tabular-nums;\n}\n\nbody.light_theme .agcx-ft-funding-popup__val {\n  color: #1e2329;\n}\n\n.agcx-ft-funding-popup__payee {\n  color: #d1aa67;\n  font-weight: 600;\n}\n\n.agcx-ft-funding-ticker__label-short {\n  display: none;\n}\n\n/* Desktop: keep Funding after Last/Change, before High/Low/Vol */\n@media screen and (min-width: 992px) {\n  .agcx-ft-ticker-stats {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n  }\n\n  .agcx-ft-ticker-last {\n    order: 1;\n  }\n\n  .agcx-ft-ticker-mark {\n    order: 2;\n  }\n\n  .agcx-ft-ticker-index {\n    order: 3;\n  }\n\n  .agcx-ft-ticker-change {\n    order: 4;\n  }\n\n  .agcx-ft-funding-ticker {\n    order: 5;\n  }\n\n  .agcx-ft-ticker-high {\n    order: 6;\n  }\n\n  .agcx-ft-ticker-low {\n    order: 7;\n  }\n\n  .agcx-ft-ticker-vol-base {\n    order: 8;\n  }\n\n  .agcx-ft-ticker-vol-quote {\n    order: 9;\n  }\n\n  .agcx-ft-funding-ticker__label-full {\n    display: inline;\n  }\n\n  .agcx-ft-funding-ticker__label-short {\n    display: none;\n  }\n}\n\n@media (max-width: 767px) {\n  .agcx-ft-batch-drawer-panel {\n    width: 100%;\n    border-radius: 16px 0 0 0;\n    max-width: 85%;\n  }\n\n  .agce-ft-mm-confirm {\n    padding: 10px 0 !important;\n    font-size: 14px !important;\n  }\n\n\n  .agce-ft-mm-segment__btn {\n    padding: 9px 0 !important;\n    font-size: 13px !important;\n  }\n\n  .agcx-ft-trade-info-item {\n    font-size: 12px;\n  }\n\n  .agce-margin-lvg-step-row button {\n    font-size: 16px;\n  }\n\n  .agce-margin-lvg-step-val {\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  .agcx-ft-batch-lvg-slider-wrap {\n    padding-bottom: 6px;\n  }\n\n}\n\n@media screen and (max-width: 991.98px) {\n\n  /* Binance mobile: 2×2 High/Low/Vol, Funding full-width underneath */\n  .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS.agcx-ft-ticker-stats {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 10px;\n    row-gap: 6px;\n    align-items: start !important;\n    width: 100%;\n  }\n\n  .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS.agcx-ft-ticker-stats>.headline_leftItem__7BFYq {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    justify-content: flex-start !important;\n    gap: 2px;\n    width: 100%;\n    min-width: 0;\n    margin-inline-start: 0 !important;\n    padding: 0;\n  }\n\n  .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS.agcx-ft-ticker-stats>.headline_leftItem__7BFYq .headline_withBorder__a6ZD2 {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n    font-weight: 200;\n    font-size: 10px;\n    line-height: 12px;\n    text-align: start;\n    margin: 0;\n    opacity: 0.75;\n  }\n\n  .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS.agcx-ft-ticker-stats>.headline_leftItem__7BFYq .headline_title__x1csO {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: start !important;\n    margin: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .headline_left__lBBPY .agcx-ft-funding-ticker.headline_leftItem__7BFYq {\n    margin-top: 4px;\n    overflow: visible;\n  }\n\n  .headline_left__lBBPY .agcx-ft-funding-ticker .agcx-ft-funding-ticker__trigger {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 2px;\n    width: 100%;\n    min-width: 0;\n  }\n\n  .headline_left__lBBPY .agcx-ft-funding-ticker .agcx-ft-funding-ticker__label {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n    font-size: 10px;\n    line-height: 12px;\n    text-align: start;\n    opacity: 0.75;\n    border-bottom: 1px dotted rgba(255, 255, 255, 0.4);\n  }\n\n  body.light_theme .headline_left__lBBPY .agcx-ft-funding-ticker .agcx-ft-funding-ticker__label {\n    border-bottom-color: rgba(0, 0, 0, 0.28);\n  }\n\n  .agcx-ft-funding-ticker__label-full {\n    display: none;\n  }\n\n  .agcx-ft-funding-ticker__label-short {\n    display: inline;\n    font-weight: 300;\n  }\n\n  .headline_left__lBBPY .agcx-ft-funding-ticker .agcx-ft-funding-ticker__value {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: baseline;\n    justify-content: flex-start;\n    gap: 0;\n    width: 100%;\n    font-size: 12px;\n    line-height: 16px;\n    text-align: left !important;\n    white-space: nowrap;\n  }\n\n  .agcx-ft-funding-ticker__countdown {\n    color: inherit;\n    opacity: 0.95;\n  }\n\n  .agcx-ft-funding-popup--portal {\n    max-height: min(70vh, 420px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .agcx-ft-funding-popup__row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n  }\n\n  .agcx-ft-funding-popup__val {\n    text-align: left;\n  }\n}\n\n.agce-ft-mm-defaults {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 12px;\n  padding: 12px 2px;\n  margin-bottom: 18px;\n  border: none;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 0;\n  background: transparent !important;\n  cursor: pointer;\n  text-align: left;\n}\n\nbody.light_theme .agce-ft-mm-defaults {\n  border-top-color: #ececee;\n}\n\n.agce-ft-mm-defaults:before {\n  display: none !important;\n}\n\n.agce-ft-mm-defaults>span:first-child {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\nbody.light_theme .agce-ft-mm-defaults>span:first-child {\n  color: #14161a;\n}\n\n.agce-ft-mm-defaults__trail {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #848e9c;\n  white-space: nowrap;\n}\n\nbody.light_theme .agce-ft-mm-defaults__trail {\n  color: #9a9da3;\n}\n\n.agce-ft-mm-confirm {\n  width: 100%;\n  border: none !important;\n  border-radius: 12px !important;\n  padding: 14px 0 !important;\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  background: #d1aa67 !important;\n  color: #1e2329 !important;\n  cursor: pointer;\n}\n\n.agce-ft-mm-confirm:before {\n  display: none !important;\n}\n\n.agce-ft-mm-confirm:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n\n.agce-ft-mm-confirm:disabled {\n  background: rgba(255, 255, 255, 0.08) !important;\n  color: #5e6673 !important;\n  cursor: not-allowed;\n  filter: none;\n}\n\nbody.light_theme .agce-ft-mm-confirm:not(:disabled) {\n  background: #d1aa67 !important;\n  color: #14161a !important;\n}\n\nbody.light_theme .agce-ft-mm-confirm:disabled {\n  background: #e7e9ec !important;\n  color: #a9adb5 !important;\n}\n\nbutton.agce-margin-leverage-trigger-btn1 {\n  cursor: pointer !important;\n}\n\n/* Adjust Leverage foot — overrides shared margin/margin.css (same class names, white Confirm) */\n.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--ghost {\n  flex: 0.65 1 0 !important;\n  max-width: 34%;\n}\n\n.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {\n  flex: 2.1 1 0 !important;\n  background: #d1aa67 !important;\n  color: #1e2329 !important;\n}\n\n.agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary:hover {\n  filter: brightness(1.05);\n  background: #d1aa67 !important;\n}\n\nbody:not(.light_theme) .agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {\n  background: #d1aa67 !important;\n  color: #1e2329 !important;\n}\n\nbody.light_theme .agce-margin-lvg-modal-foot .agce-margin-lvg-btn--primary {\n  background: #d1aa67 !important;\n  color: #14161a !important;\n}\n\n/* ── Futures trade load skeletons ─────────────────────────────────────────── */\n.agcx-ft-ob-skel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 8px;\n  min-height: 160px;\n  box-sizing: border-box;\n}\n\n.agcx-ft-ob-skel__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n  width: 100%;\n}\n\n.agcx-ft-ob-skel__cell {\n  display: block;\n  height: 10px;\n  min-height: 10px;\n  min-width: 0;\n  width: 100%;\n  border-radius: 3px;\n}\n\n.agcx-ft-buysell-skel {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 12px 12px 16px;\n  min-height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  flex: 1 1 auto;\n}\n\n/* Stretch skeleton to the full buy/sell card height (aligned with order book column). */\n.trade_card.buysell_card.buysell_two {\n  display: flex;\n  flex-direction: column;\n}\n\n.trade_card.buysell_card.buysell_two>.agcx-ft-buysell-skel {\n  flex: 1 1 auto;\n  min-height: 520px;\n}\n\n.agcx-ft-buysell-skel__top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.agcx-ft-buysell-skel__chip {\n  display: block;\n  height: 30px;\n  width: 108px;\n  min-width: 88px;\n  border-radius: 8px;\n}\n\n.agcx-ft-buysell-skel__modes {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.agcx-ft-buysell-skel__mode {\n  display: block;\n  height: 22px;\n  width: 64px;\n  min-width: 52px;\n  border-radius: 4px;\n}\n\n.agcx-ft-buysell-skel__info {\n  display: block;\n  height: 16px;\n  width: 16px;\n  min-width: 16px;\n  margin-left: auto;\n  border-radius: 50%;\n}\n\n.agcx-ft-buysell-skel__split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  flex: 1 1 auto;\n  align-items: stretch;\n  min-height: 0;\n}\n\n.agcx-ft-buysell-skel__col {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n\n.agcx-ft-buysell-skel__avail {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.agcx-ft-buysell-skel__label {\n  display: block;\n  height: 12px;\n  width: 72px;\n  min-width: 56px;\n  border-radius: 4px;\n}\n\n.agcx-ft-buysell-skel__val {\n  display: block;\n  height: 12px;\n  width: 96px;\n  min-width: 64px;\n  border-radius: 4px;\n}\n\n.agcx-ft-buysell-skel__field {\n  display: block;\n  height: 42px;\n  width: 100%;\n  min-width: 0;\n  border-radius: 8px;\n}\n\n.agcx-ft-buysell-skel__slider {\n  display: block;\n  height: 10px;\n  width: 100%;\n  min-width: 0;\n  margin-top: 2px;\n  border-radius: 6px;\n}\n\n.agcx-ft-buysell-skel__ticks {\n  display: flex;\n  justify-content: space-between;\n  gap: 6px;\n  margin-top: -2px;\n}\n\n.agcx-ft-buysell-skel__tick {\n  display: block;\n  height: 8px;\n  width: 18px;\n  min-width: 14px;\n  border-radius: 3px;\n}\n\n.agcx-ft-buysell-skel__check {\n  display: block;\n  height: 14px;\n  width: 88px;\n  min-width: 64px;\n  border-radius: 4px;\n}\n\n.agcx-ft-buysell-skel__cta {\n  display: block;\n  height: 40px;\n  width: 100%;\n  min-width: 0;\n  margin-top: auto;\n  border-radius: 8px;\n}\n\n.agcx-ft-buysell-skel__fee {\n  display: flex;\n  align-items: center;\n  padding-top: 4px;\n}\n\n.agcx-ft-buysell-skel__fee-line {\n  display: block;\n  height: 12px;\n  width: 70%;\n  max-width: 280px;\n  min-width: 140px;\n  border-radius: 4px;\n}\n\n@media screen and (max-width: 991.98px) {\n  .agcx-ft-buysell-skel__split {\n    grid-template-columns: 1fr;\n  }\n\n  .agcx-ft-buysell-skel__col--sell {\n    display: none;\n  }\n}\n\n.agcx-ft-acct-skel__title {\n  display: block;\n  height: 18px;\n  width: 88px;\n  min-width: 88px;\n  border-radius: 4px;\n}\n\n.agcx-ft-acct-skel__section-title {\n  display: block;\n  height: 12px;\n  width: 96px;\n  min-width: 96px;\n  margin-bottom: 10px;\n  border-radius: 4px;\n}\n\n.agcx-ft-acct-skel__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.agcx-ft-acct-skel__label {\n  display: block;\n  height: 12px;\n  width: 110px;\n  min-width: 72px;\n  border-radius: 4px;\n}\n\n.agcx-ft-acct-skel__val {\n  display: block;\n  height: 12px;\n  width: 88px;\n  min-width: 64px;\n  border-radius: 4px;\n}\n\n.agcx-ft-acct-skel__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.agcx-ft-acct-skel__action {\n  display: block;\n  height: 32px;\n  flex: 1;\n  min-width: 0;\n  border-radius: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
